<div class="row">
    <div class="col-md-4 col-12 col-sm-6 col-lg-3">
        <div class="card bg-color-pink-ligth h-100 text-white">
            <div class="card-body d-flex flex-column justify-content-center text-center">
                <h6 class="card-title"> VENTA SEMANAL </h6>
                <p class="card-text fw-bold" *ngIf="sellsPerOffice">
                    {{ sellsPerOffice.totalPerOffice | currency: 'MXN' }}
                </p>
            </div>
        </div>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <div class="card bg-color-pink-ligth h-100 shadow-sm text-white">
            <div class="card-body d-flex flex-column justify-content-center text-center">
                <h6 class="card-title mb-3">
                    PORCENTAJE DE COBRANZA
                </h6>

                <div class="fw-bold" *ngIf="sellsPerOffice && sellsPerOffice.percentageEmployee === 0">
                    No hay cobranza
                </div>

                <div class="mt-2" *ngIf="sellsPerOffice && sellsPerOffice.percentageEmployee > 0">
                    <div class="progress" style="height: 25px;">
                        <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar"
                            [style.width.%]="sellsPerOffice.percentageEmployee" [attr.aria-valuenow]="sellsPerOffice.percentageEmployee"
                            aria-valuemin="0" aria-valuemax="100">
                                {{ sellsPerOffice.percentageEmployee }} %
                        </div>
                    </div>
                </div>
                <!--
                <div *ngIf="sellsPerOffice?.percentageEmployee > 0" class="mt-2">
                    <div class="progress" style="height: 25px;">
                        <div
                            class="progress-bar progress-bar-striped progress-bar-animated bg-success"
                            role="progressbar"
                            [style.width.%]="sellsPerOffice.percentageEmployee"
                            [attr.aria-valuenow]="sellsPerOffice.percentageEmployee"
                            aria-valuemin="0"
                            aria-valuemax="100"
                        >
                            {{ sellsPerOffice.percentageEmployee }} %
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</div>

<div class="row mb-2 mt-2 justify-content-end">
    <div class="col-md-4 mt-3">
        <button type="button" class="btn btn-primary" (click)="openBoxClose()">
            Corte de caja
        </button>
        <button type="button" class="btn btn-info ms-1" *ngIf="keyRole === 'admin' || keyRole === 'gte' || keyRole === 'eds'"
            (click)="scheduleVacationsTemplate($event)">
            Vacaciones
        </button>
        <button type="button" class="btn btn-warning ms-1" (click)="iconsMapFn()">
            Iconos
        </button>
    </div>
    <div class="col-md-4 mt-3">
        <div class="input-group">
            <input #dateInput type="text" class="form-control" ngbDatepicker placeholder="Selecciona una fecha" 
                #dp="ngbDatepicker" (dateSelect)="onDateSelected($event, dateInput); dp.close()" (click)="dp.toggle()" />
            <button type="button" class="btn btn-outline-secondary bi bi-calendar3" (click)="dp.toggle()"></button>
            <button type="button" (click)="clearDay(dateInput)" class="btn btn-danger"> Limpiar </button>
        </div>
    </div>
    <div class="col-md-4 mt-1">
        <form [formGroup]="clientsSearchForm">
            <select2 style="margin-left: -10px; margin-right: 8px" [data]="clientsOptions" formControlName="searchClient"
                displaySearchStatus="always" placeholder="Selecciona un cliente" resettable listPosition="below" styleMode="material"
                noResultMessage="Cliente no encontrado" (update)="showDataPerClient($event)"><!-- calendarPerClientDate -->
            </select2>
            <button (click)="buttonClear()" class="btn btn-success"> Limpiar </button>
        </form>
    </div>
</div>

<full-calendar #calendar [options]="calendarOptions"></full-calendar>

<div class="mt-3 mb-3">
    &nbsp;
</div>

<!-- TEMPLATES -->
<!-- Information about session ** start ** -->
<ng-template #modalContent let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">
            Cita - {{ dataSessionInfo?.client?.name }}
            (
                <span class="fw-bold text-success" *ngIf="dataSessionInfo?.assisted === 1">
                    Asistio /
                </span>
                <span class="fw-bold text-danger" *ngIf="dataSessionInfo?.assisted === 0">
                    No asistio /
                </span>
                <span class="fw-bold text-success" *ngIf="dataSessionInfo?.sessionClose === true">
                    Sesi&oacute;n cerrada
                </span>
                <span class="fw-bold text-danger" *ngIf="dataSessionInfo?.sessionClose === false">
                    Sesi&oacute;n abierta
                </span>
            )
            <span *ngIf="dataSessionInfo?.typeSession === 2">
                - Sesi&oacute;n de valoraci&oacute;n -
            </span>
            <button type="button" class="btn btn-outline-success ms-2" (click)="showFormEditSession($event)">
                Editar Sesi&oacute;n
            </button>
            <button class="btn btn-outline-danger ms-2" type="button" (click)="deleteSession(dataSessionInfo?.session_id)">
                <span *ngIf="dataSessionInfo?.typeSession !== 2">
                    Eliminar Sesi&oacute;n
                </span>
                <span *ngIf="dataSessionInfo?.typeSession === 2">
                    Eliminar Valoraci&oacute;n
                </span>
            </button>
        </h5>
        <button class="close ms-auto" type="button" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="alert alert-success" role="alert" *ngIf="assistedFlag && submitAssisted">
            {{ messageTextAssisted }}
        </div>

        <div *ngIf="editHourSession">
            <div class="card mb-1">
                <div class="card-body">
                    <h5 class="card-title mb-1">
                        Cambio de horario de sesi&oacute;n
                    </h5>
                    <div class="card-title">
                        <form novalidate [formGroup]="updateFormSession" (ngSubmit)="updateDataSession()">
                            <input type="hidden" name="sessionId" formControlName="sessionId" id="sessionId" />
                            <input type="hidden" name="originalCabin" formControlName="originalCabin" id="originalCabin" />
                            <input type="hidden" name="duration" formControlName="duration" id="duration" />

                            <div class="row mb-3">
                                <div class="col-md-3 offset-md-2">
                                    <label for="startSession"> Hora de inicio </label>
                                    <ngb-timepicker [(ngModel)]="startSession"
                                        [ngModelOptions]="{ standalone: true }"
                                        [minuteStep]="step"
                                        [spinners]="true"
                                        (ngModelChange)="changeHour(true)">
                                    </ngb-timepicker>
                                </div>
                                <div class="col-md-3 offset-md-2">
                                    <label for="endSession"> Hora de fin </label>
                                    <ngb-timepicker [(ngModel)]="endSession"
                                        [ngModelOptions]="{ standalone: true }"
                                        [minuteStep]="step"
                                        [spinners]="true">
                                    </ngb-timepicker>
                                    <div class="text-danger" *ngIf="uptHourSubmitExists">
                                        Por favor, selecciona una hora de termino de sesion.
                                    </div>
                                </div>
                            </div>
            
                            <div class="row">
                                <div class="form-floating mb-3 mt-3-col-md-12">
                                    <select name="cabinNumber" id="cabinNumber"
                                        class="form-select" aria-label="floating label select"
                                        formControlName="cabinNumber">
                                        <option value=""> Seleccione una cabina </option>
                                        <option value="{{ cabin.id }}" *ngFor="let cabin of cabins">
                                            {{ cabin.name }}
                                        </option>
                                    </select>
                                    <label for="cabinNumber" class="ms-2">  
                                        Selecciona una cabina
                                    </label>
                                </div>
                            </div>

                            <div class="row">
                                <div class="d-grip gap-2 d-md-flex justify-content-md-end">
                                    <button type="submit" class="btn btn-outline-success">
                                        Aceptar cambio de horario
                                    </button>
                                    <button type="button" (click)="showFormEditSession($event)" class="btn btn-outline-danger">
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!editHourSession">
            <div class="card mb-1 ms-1 me-1" *ngIf="!acceptedSession">
                <div class="card-body">
                    <div class="row">
                        <div class="ms-1 me-1 btn-group">
                            <button class="btn btn-success"
                                type="button"
                                (click)="assistedUser(1, dataSessionInfo?.session_id)">
                                    <i class="bi bi-check-circle icon-color-button"></i>
                                    Si Asistio
                            </button>
                            <button type="button"
                                class="btn btn-danger"
                                (click)="noAssistedUser(true, 0)">
                                    <i class="bi bi-x-circle icon-color-button"></i>
                                    No Asistio
                            </button>
                            <button type="button"
                                class="btn btn-warning"
                                (click)="showRescheduleForm(true)">
                                    <i class="bi bi-calendar3"></i>
                                    Reagendar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mb-2" *ngIf="noAssistFlag">
                <div class="card-body">
                    <h5 class="card-title">
                        Raz&oacute;n de <strong>No Asistencia</strong>
                    </h5>
                    <div class="card-title">
                        <form [formGroup]="cancelForm" (ngSubmit)="noAssistChecks()" novalidate>
                            <input type="hidden" name="id" formControlName="id" />
                            <input type="hidden" name="type" formControlName="type" />

                            <div class="row">
                                <div class="mb-3 input-group">
                                    <span class="input-group-text"> Comentarios </span>
                                    <textarea name="comments" 
                                        id="comments"
                                        class="form-control"
                                        formControlName="comments"
                                        aria-label="Comentarios">
                                    </textarea>
                                </div>
                            </div>
                            <div class="row">
                                <div class="d-grip gap-2 d-md-flex justify-content-md-end">
                                    <button type="submit" class="btn btn-outline-success me-2">
                                        Confirmar no asistencia 213
                                    </button>
                                    <button type="button" (click)="noAssistedUser(false, 1)" class="btn btn-outline-danger ms-1">
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <!-- Rescheduled session ** start ** -->
            <div class="alert alert-success mt-2" role="alert"
                *ngIf="submitReschedule && messageTextReschedule !== ''">
                    {{ messageTextReschedule }}
            </div>
            <div class="card mb-1" *ngIf="rescheduleFlag">
                <div class="card-body">
                    <h5 class="card-title">
                        Reagendar Sesi&oacute;n
                    </h5>
                    <div class="card-title">
                        <form [formGroup]="rescheduleForm" (ngSubmit)="rescheduleSession()" novalidate>
                            <input type="hidden" name="sessionId" formControlName="sessionId" />
                            <div class="row">
                                <div class="mb-3 form-floating">
                                    <div class="input-group">
                                        <input type="text" name="newDay" id="newDay"
                                            class="form-control" formControlName="newDay"
                                            placeholder="Fecha a reagendar sesion"
                                            ngbDatepicker #d="ngbDatepicker" required
                                            readonly style="height: 3.5rem;" 
                                            [ngClass]="{
                                                'is-valid': submitReschedule && !rescheduleSessionFn.new_day.errors,
                                                'is-invalid': submitReschedule && rescheduleSessionFn.new_day.errors
                                            }">
                                        <button type="button" class="btn btn-outline-secondary bi bi-calendar3"
                                            (click)="d.toggle()">
                                        </button>
                                        <div *ngIf="rescheduleSessionFn.newDay?.errors.required && 
                                                    rescheduleSessionFn.newDay?.errors.invalid && 
                                                    submitReschedule">
                                            <div class="text-danger" *ngIf="rescheduleSessionFn.newDay.errors.required">
                                                Por favor, seleccione una fecha para reagendar la sesi&oacute;n
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-md-3 offset-md-2">
                                    <label for="startSession">Hora de inicio</label>
                                    <ngb-timepicker
                                        [(ngModel)]="startSession"
                                        [ngModelOptions]="{ standalone: true }"
                                        [spinners]="true">
                                    </ngb-timepicker>
                                </div>
                                <div class="col-md-3 offset-md-2">
                                    <label for="endSession">Hora de fin</label>
                                    <ngb-timepicker
                                        [(ngModel)]="endSession"
                                        [ngModelOptions]="{ standalone: true }"
                                        [minuteStep]="step"
                                        [spinners]="true">
                                    </ngb-timepicker>
                                    <div class="text-danger" *ngIf="submitExists">
                                        Por favor, selecciona una hora de termino de sesion.
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="d-grip gap-2 d-md-flex justify-content-md-end">
                                    <button type="submit" class="btn btn-outline-success">
                                        Aceptar reagenda
                                    </button>
                                    <button type="button" (click)="showRescheduleForm(false)" class="btn btn-outline-danger">
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- Rescheduled session ** end ** -->

            <!-- Buttons para pago adelantados / insumos ** start ** -->
            <div class="row mb-1" *ngIf="dataSessionInfo?.typeSession === 1">
                <div class="btn-group">
                    <button type="button" class="btn btn-success" (click)="newPaymentsAddedSession(true)">
                        Realizar pagos adelantados
                    </button>
                    <button type="button" class="btn btn-info" (click)="newExtraResources(true)" *ngIf="acceptedSession && !areasWorkedFlag">
                        Pago de insumos extras
                    </button>
                </div>
            </div>
            <!-- Buttons para pago adelantados / insumos ** end ** -->

            <!-- Pagos adelantados ** start ** -->
            <div class="alert alert-success" role="alert" *ngIf="submitAdvancePayment">
                {{ messageAdvancePayments }}
            </div>
            <div *ngIf="newPaymentsAdded">
                <div class="card mt-1 mb-1" *ngIf="newPaymentsAdded">
                    <div class="card-body">
                        <h5 class="card-title mb-1 mt-1">
                            Pagos adelantados
                        </h5>
                        <form [formGroup]="addPaymentsForm" (ngSubmit)="addNewPayments()" novalidate>
                            <input type="hidden" name="sessionId" formControlName="sessionId" />
                            <input type="hidden" name="apptId" formControlName="apptId" />

                            <div class="mb-3 form-floating">
                                <input type="text" name="amount" id="amount"
                                    formControlName="amount" class="form-control"
                                    placeholder="Cantidad a pagar" required
                                    [ngClass]="{
                                        'is-invalid': submitAdvancePayment && advancePaymentFn.amount.errors,
                                        'is-valid': submitAdvancePayment && !advancePaymentFn.amount.errors
                                    }">
                                <label for="amount"> Cantidad a pagar </label>
                            </div>

                            <div class="mb-3 form-floating">
                                <select name="paymentMethodId" id="paymentMethodId" class="form-control"
                                    formControlName="paymentMethodId" placeholder="Metodo de pago"
                                    (change)="checkPaymentMethods($event, 'session')"
                                    required
                                    [ngClass]="{
                                        'is-invalid': submitAdvancePayment && advancePaymentFn.paymentMethodId.errors,
                                        'is-valid': submitAdvancePayment && !advancePaymentFn.paymentMethodId.errors
                                    }">
                                        <option value="" selected>Seleccione un metodo de pago</option>
                                        <option value="{{ paymentMethod.id }}" *ngFor="let paymentMethod of paymentMethods">
                                            {{ paymentMethod.payment_name }}
                                        </option>
                                </select>
                                <label for="paymentMethodId">Seleccione un metodo de pago</label>
                            </div>

                            <div class="form-floating mb-3">
                                <select name="paymentId" id="paymentId" class="form-control"
                                    formControlName="paymentId" placeholder="Tipo de pago" required
                                    [ngClass]="{
                                        'is-invalid': submitAdvancePayment && advancePaymentFn.paymentId.errors,
                                        'is-valid': submitAdvancePayment && !advancePaymentFn.paymentId.errors
                                    }">
                                        <option value="0">Seleccione un tipo de pago</option>
                                        <option value="{{ payment.id }}" *ngFor="let payment of paymentsFilter">
                                            {{ payment.name }}
                                        </option>
                                </select>
                                <label for="paymentId">Tipo de pago</label>
                            </div>

                            <div class="mb-3 form-floating" *ngIf="paymentsFilter.length > 0 && paymentMethodFlag">
                                <select name="terminal" id="terminal" class="form-control"
                                    formControlName="terminal" placeholder="Seleccione una terminal" required
                                    [ngClass]="{
                                        'is-invalid': submitAdvancePayment && advancePaymentFn.terminal.errors,
                                        'is-valid': submitAdvancePayment && !advancePaymentFn.terminal.errors
                                    }">
                                        <option value="0" selected>Seleccione una terminal</option>
                                        <option value="Banorte">Banorte</option>
                                        <option value="BBVA">BBVA</option>
                                        <option value="Firstdata">Firstdata</option>
                                        <option value="Netpay">Netpay</option>
                                        <option value="Getnet">Getnet</option>
                                </select>
                                <label for="terminal">Seleccione una terminal</label>
                            </div>

                            <div class="d-grip gap-2 d-md-flex justify-content-md-end">
                                <button class="btn btn-danger" type="submit" (click)="newPaymentsAddedSession(false)">
                                    Cancelar
                                </button>
                                <button class="btn btn-primary me-md-2" type="submit" [disabled]="assistedFlag">
                                    Realizar pago adelantado
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- Pagos adelantados ** end ** -->

            <!-- Pago de insumos extras ** start ** -->
            <div *ngIf="newExtraPays">
                <div class="alert alert-success" role="alert" *ngIf="submitExtraPayments && extraPaymentSession">
                    {{ messageExtraPaymentSession }}
                </div>

                <div class="card mt-1 mb-1" *ngIf="acceptedSession && !areasWorkedFlag">
                    <div class="card-body">
                        <h5 class="card-title mb-1 mt-1"> Pago de insumos extras </h5>
                        <form [formGroup]="extraProductsForm" (ngSubmit)="saveExtraProducts()">
                            <input type="hidden" name="sessionId" formControlName="sessionId" />
                            <input type="hidden" name="remainingPayment" formControlName="remainingPayment" />
                            
                            <div class="mb-3">
                                <input type="hidden" name="amount" formControlName="amount" />
                                <div class="form-check">
                                    <input type="radio" name="extra" id="extra1" class="form-check-input"
                                        formControlName="extra" value="1" (change)="changeElement($event)" />
                                    <label for="form-check-label ms-2">Rastrillo</label>
                                </div>
                                <div class="form-check">
                                    <input type="radio" name="extra" id="extra2" formControlName="extra"
                                        class="form-check-input" value="2" (change)="changeElement($event)" />
                                    <label for="form-check-label ms-2">Perfilador</label>
                                </div>
                                <div class="form-check">
                                    <input type="radio" name="extra" id="extra3" formControlName="extra"
                                        class="form-check-input" value="3" (change)="changeElement($event)" />
                                    <label for="form-check-input ms-2">Ambos</label>
                                </div>
                            </div>

                            <div class="form-floating mb-3">
                                <select name="paymentMethodId" id="paymentMethodId" class="form-control"
                                    formControlName="paymentMethodId" placeholder="Metodo de Pago"
                                    (change)="checkPaymentMethods($event, 'extra')" required
                                    [ngClass]="{
                                        'is-invalid': submitExtraPayments && extraProductFn.paymentMethodId.errors,
                                        'is-valid': submitExtraPayments && !extraProductFn.paymentMethodId.errors
                                    }">
                                        <option value="0" selected> Seleccione un metodo de pago </option>
                                        <option value="{{ paymentMethod.id }}" *ngFor="let paymentMethod of paymentMethods">
                                            {{ paymentMethod.payment_name }}
                                        </option>
                                </select>
                                <label for="paymentMethodId">
                                    Seleccione un metodo de pago
                                </label>
                            </div>

                            <div class="form-floating mb-3" *ngIf="paymentsFilter.length > 0 && extraShowFlag">
                                <select name="paymentId" id="paymentId" class="form-control"
                                    formControlName="paymentId" placeholder="Tipo de pago" required
                                    [ngClass]="{
                                        'is-invalid': submitExtraPayments && extraProductFn.paymentId.errors,
                                        'is-valid': submitExtraPayments && !extraProductFn.paymentId.errors
                                    }">
                                        <option value="0" selected>Selecciona un tipo de pago</option>
                                        <option value="{{ payment.id }}" *ngFor="let payment of paymentsFilter">
                                            {{ payment.name }}
                                        </option>
                                </select>
                                <label for="paymentId">Tipo de pago</label>
                            </div>

                            <div class="mb-3 form-floating" *ngIf="paymentsFilter.length > 0 && extraShowFlag">
                                <select name="terminal" id="terminal" class="form-control"
                                    formControlName="terminal" placeholder="Selecciona una terminal" required
                                    [ngClass]="{
                                        'is-invalid': submitExtraPayments && extraProductFn.terminal.errors,
                                        'is-valid': submitExtraPayments && !extraProductFn.terminal.errors
                                    }">
                                        <option value="0" selected>Seleccione una terminal</option>
                                        <option value="Banorte">Banorte</option>
                                        <option value="BBVA">BBVA</option>
                                        <option value="Firstdata">Firstdata</option>
                                        <option value="Netpay">Netpay</option>
                                        <option value="Getnet">Getnet</option>
                                </select>
                                <label for="terminal">Seleccione una terminal</label>
                            </div>

                            <div class="row">
                                <span>
                                    <strong>
                                        Saldo Total: {{ saldoExtraTotal | currency: "MXN" }}
                                    </strong>
                                </span>
                            </div>

                            <div class="d-grip gap-2 d-md-flex justify-content-md-end">
                                <button type="submit" class="btn btn-danger" (click)="newExtraResources(false)">
                                    Cancelar
                                </button>
                                <button type="submit" class="btn btn-primary me-md-2" [disabled]="submitExtraPayments">
                                    Pagar insumos extras
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- Pago de insumos extras ** end ** -->

            <!-- Cobro de sesion ** start ** -->
            <div *ngIf="!hasRemaining && dataSessionInfo?.completeSession">
                <div class="mt-2 alert alert-success" role="alert" *ngIf="messageTextPaymentDone !== ''">
                    {{ messageTextPaymentDone }}
                </div>
                <div class="card mt-1 mb-1" *ngIf="acceptedSession && !paymentDoneFlag 
                    && dataSessionInfo?.shouldPaid?.id && !disabledButtons && paymentsInfo.length !== 0">
                    <div class="card-body">
                        <h5 class="card-title mb-1 mt-1">
                            Cobro de sesi&oacute;n {{ dataSessionInfo?.numberSession }}
                        </h5>

                        <form [formGroup]="paymentsForm" (ngSubmit)="savePaymentsSession()" novalidate>
                            <input type="hidden" name="sessionId" formControlName="sessionId" />
                            <input type="hidden" name="remainingPaymentId" formControlName="remainingPaymentId" />
                            <input type="hidden" name="apptId" formControlName="apptId" />
                            <input type="hidden" name="originalAmount" formControlName="originalAmount" />

                            <div class="mb-2 form-floating">
                                <input type="text" class="form-control" name="amount" id="amount" formControlName="amount"
                                    placeholder="Cantidad a pagar" required [readonly]="disabledAmountField"
                                    (keyUp)="changePriceLabel($event)"
                                    ngClass]="{
                                        'is-invalid': submitPayments && paymentsFormFn.amount.errors,
                                        'is-valid': submitPayments && !paymentsFormFn.amount.errors
                                    }" />
                                <label for="amont">Cantidad a pagar</label>
                            </div>

                            <div class="mb-2 ms 2">
                                <input type="checkbox" name="changeAmount" id="changeAmount" class="form-check-input"
                                    (change)="changeAmountToPaid($event)" />
                                <label for="changeAmount" class="form-check-label ms-2"> Cambiar cantidad a pagar </label>
                            </div>

                            <div class="form-floating mb-3">
                                <select name="paymentMethodId" id="paymentMethodId" class="form-control" formControlName="paymentMethodId"
                                    placeholder="Metodo de pago" (change)="checkPaymentMethods($event, 'session')" required
                                    [ngClass]="{
                                        'is-invalid': submitPayments && paymentsFormFn.paymentMethodId.errors,
                                        'is-valid': submitPayments && !paymentsFormFn.paymentMethodId.errors
                                    }">
                                    <option value="" selected> Seleccione un metodo de pago </option>
                                    <option value="{{ paymentMethod.id }}" *ngFor="let paymentMethod of paymentMethods">
                                        {{ paymentMethod.payment_name }}
                                    </option>
                                </select>
                                <label for="paymentMethodId"> Metodo de pago </label>
                            </div>

                            <div class="form-floating mb-3" *ngIf="paymentsFilter.length > 0 && !extraShowFlag">
                                <select name="paymentId" id="paymentId" class="form-control" formControlName="paymentId"
                                    placeholder="Tipo de pago" required
                                    [ngClass]="{
                                        'is-invalid': submitPayments && paymentsFormFn.paymentId.errors,
                                        'is-valid': submitPayments && !paymentsFormFn.paymentId.errors
                                    }">
                                        <option value="0" selected>Selecciona un tipo de pago</option>
                                        <option value="{{ payment.id }}" *ngFor="let payment of paymentsFilter">
                                            {{ payment.name }}
                                        </option>
                                </select>
                                <label for="paymentId"> Tipo de pago </label>
                            </div>

                            <div class="form-floating mb-3" *ngIf="paymentsFilter.length > 0 && !extraShowFlag">
                                <select name="terminal" id="terminal" class="form-control" formControlName="terminal"
                                    placeholder="Seleccione una terminal" required
                                    [ngClass]="{
                                        'is-invalid': submitPayments && paymentsFormFn.terminal.errors,
                                        'is-valid': submitPayments && !paymentsFormFn.terminal.errors
                                    }">
                                        <option value="0" selected>Seleccione una terminal</option>
                                        <option value="Banorte">Banorte</option>
                                        <option value="BBVA">BBVA</option>
                                        <option value="Firstdata">Firstdata</option>
                                        <option value="Netpay">Netpay</option>
                                        <option value="Getnet">Getnet</option>
                                </select>
                                <label for="terminal"> Selecciona una terminal </label>
                            </div>

                            <div class="row">
                                <span>
                                    <strong>
                                        Saldo Total: {{ saldoTotal | currency: 'MXN' }}
                                    </strong>
                                </span>
                            </div>

                            <div class="d-grip gap-2 d-md-flex justify-content-md-end" *ngIf="!isPaidFlag">
                                <button class="btn btn-primary me-md-2" type="submit" [disabled]="assistedFlag">
                                    Pagar sesi&oacute;n
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- Cobro de sesion ** end ** -->

            <!-- Areas trabajadas por sesion ** start ** -->
            <div *ngIf="!areasWorkedFlag && dataSessionInfo?.typeSession === 1">
                <div class="mt-2 alert alert-success" role="alert" *ngIf="messagesAreasWork !== ''">
                    {{ messagesAreasWork }}
                </div>
                
                <div class="card mb-1" 
                    *ngIf="(dataSessionInfo?.shouldPaid.id && acceptedSession && !areasWorkedFlag && paymentDoneFlag) ||
                           (acceptedSession && !paymentDoneFlag && !areasWorkedFlag && dataSessionInfo?.typeSession 
                            && !disabledButtons && !dataSessionInfo?.shouldPaid.id)">
                    <div class="card-body">
                        <h5 class="card-title mb-1 mt-1">
                            Areas trabajadas en la sesi&oacute;n
                        </h5>
                        <form [formGroup]="missingForm" (ngSubmit)="missingAreasSession()" novalidate>
                            <input type="hidden" name="sessionId" formControlName="sessionId" id="sessionId" />
                            <input type="hidden" name="apptId" formControlName="apptId" id="apptId" />
                            <input type="hidden" name="areas" formControlName="areas" id="areas" />
                            <input type="hidden" name="packageId" formControlName="packageId" id="packageId" />

                            <div class="row">
                                <div class="col-md-4" *ngFor="let areas of areasWorked">
                                    <div class="form-check">
                                        <input type="checkbox" class="form-check-input" (change)="workingAreas($event, areas.id, 2)"
                                            id="{{ areas.id }}-{{ areas.name }}" [disabled]="disabledChecks">
                                        <label for="{{ areas.id }}-{{ areas.name }}" class="form-check-label">
                                            {{ areas.name }}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-check" style="margin-left: 12px !important">
                                    <input type="checkbox" class="form-check-input" [disabled]="disabledAll"
                                        id="all" (change)="workingAreas($event, 'All', 1)" />
                                    <label for="all" class="form-check-label">
                                        Todas las areas se trabajaron
                                    </label>
                                </div>
                            </div>

                            <div class="d-grip gap-2 d-md-flex justify-content-md-end">
                                <button class="btn btn-primary me-md-2" type="submit" [disabled]="assistedFlag">
                                    Guardar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- Areas trabajadas por sesion ** end ** -->

            <!-- Finalizar sesion ** start ** -->
            <div *ngIf="dataSessionInfo?.sessionClose === false && !sessionFinishedFlag && areasWorkedFlag">
                <div class="alert alert-success" role="alert" *ngIf="submitComments && messageTextFinishSession !== ''">
                    {{ messageTextFinishSession }}
                </div>
                <!-- Valoration: {{ valorationFlag | json }}
                Accepted: {{ acceptedSession | json }}
                paymentDone: {{ paymentDoneFlag | json }}
                areasWorked: {{ areasWorkedFlag | json }}
                assistedFlag: {{ assistedFlag | json }}
                sessionFinished: {{ sessionFinishedFlag | json }}
                Type Session: {{ typeSession | json }}
                Areas flag: {{ areasFlagDone | json }} -->
                <!-- *ngIf="(valorationFlag && acceptedSession) ||
                    (acceptedSession && paymentDoneFlag && areasWorkedFlag && assistedFlag && !sessionFinishedFlag) ||
                    (typeSession && !sessionFinishedFlag) || areasFlagDone" -->
                <div class="card mb-1" *ngIf="(valorationFlag && acceptedSession) ||
                                            (acceptedSession && !paymentDoneFlag && areasWorkedFlag && assistedFlag && !sessionFinishedFlag) ||
                                            (typeSession && !sessionFinishedFlag) || areasFlagDone">
                        <div class="card-body">
                            <div class="card-title"> 
                                Finalizar Sesi&oacute;n
                            </div>
                            <div class="card-text">
                                <form [formGroup]="finalCommentsForm" (ngSubmit)="updateSession(dataSessionInfo?.session_id)" novalidate>
                                    <div class="row">
                                        <div class="form-floating mb-3 col-md-12">
                                            <select name="employeeId" id="employeeId" class="form-control" 
                                                formControlName="employeeId" required
                                                [ngClass]="{
                                                    'is-valid': submitComments && !finalCommentsFormFn.employeeId.errors,
                                                    'is-invalid': submitComments && finalCommentsFormFn.employeeId.errors
                                                }">
                                                    <option value="" selected>
                                                        Selecciona a tu enfermera
                                                    </option>
                                                    <option value="{{ employee.id }}" *ngFor="let employee of employees">
                                                        {{ employee.first_name }} {{ employee.last_name }} ({{ employee.email }})
                                                    </option>
                                            </select>
                                            <label for="employeeId" class="ms-2">
                                                Selecciona a tu enfermera
                                            </label>
                                        </div>
                                    </div>

                                    <div class="input-group mb-3">
                                        <span class="input-group-text"> Comentarios </span>
                                        <textarea name="finalComment" id="finalComment" class="form-control"
                                            formControlName="finalComment" aria-label="Comentarios"
                                            [ngClass]="{
                                                'is-invalid': submitComments && finalCommentsFormFn.finalComment.errors,
                                                'is-valid': submitComments && !finalCommentsFormFn.finalComment.errors
                                            }"></textarea>
                                    </div>

                                    <div class="row">
                                        <div class="d-grip gap-2 d-md-flex justify-content-md-end">
                                            <button type="submit" class="btn btn-outline-success">
                                                Finalizar Sesi&oacute;n
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                </div>
            </div>
            <!-- Finalizar sesion ** end ** -->

            <!-- Mostrar mensaje de razon de razon si asistio o no ** start ** -->
            <div class="alert alert-danger" role="alert" *ngIf="dataSessionInfo?.assisted === 0">
                <span *ngIf="!dataSessionInfo?.reason">
                    Razon: No hay raz&oacute;n por la que no asistio a la sesi&oacute;n.
                </span>
                <span *ngIf="dataSessionInfo?.reason">
                    Razon: {{ dataSessionInfo?.reason }}
                </span>
            </div>
            <!-- Mostrar mensaje de razon de razon si asistio o no ** start ** -->

            <!-- Informacion del cliente ** start ** -->
            <div class="card mb-1">
                <div class="card-body">
                    <h5 class="card-title">
                        Informacion del cliente
                        <strong class="color: green" *ngIf="dataSessionInfo?.shared">
                            ( Paquete compartido )
                        </strong>
                    </h5>
                    <p class="card-text">
                        Nombre del cliente: <strong>{{ dataSessionInfo?.client.name }}</strong>
                        <br />
                        Correo electronico: <strong>{{ dataSessionInfo?.client.email }}</strong>
                        <br />
                        Telefono: <strong>{{ dataSessionInfo?.client.phone }}</strong>
                        <br />
                        Sucursal: <strong>{{ dataSessionInfo?.office.name }}</strong>
                        <br />
                        Fecha de compra: <strong>{{ dataSessionInfo?.package.purchased }}</strong>
                        <br />
                        Comentarios de la sesi&oacute;n: <strong>{{ dataSessionInfo?.comments }}</strong>
                    </p>
                </div>
            </div>
            <!-- Informacion del cliente ** end ** -->

            <!-- Informacion del colaborador ** start ** -->
            <div class="card mb-1">
                <div class="card-body">
                    <h5 class="card-title"> Informacion del colaborador </h5>
                    <p class="card-text">
                        Nombre del colaborador (Vendedor): 
                        <strong>{{ dataSessionInfo?.employee.first_name }} {{ dataSessionInfo?.employee.last_name }}</strong>
                        <br />
                        Correo electronico: <strong> {{ dataSessionInfo?.employee.email }}</strong>
                    </p>
                </div>
            </div>
            <!-- Informacion del colaborador ** end ** -->

            <!-- Informacion del paquete ** start ** -->
            <div class="card mb-1" *ngIf="!valorationFlag">
                <div class="card-body">
                    <h5 class="card-title"> Informacion del paquete </h5>
                    <div class="card-text">
                        Costo total del paquete: <strong> {{ dataSessionInfo?.package.subtotal | currency: 'MXN' }} </strong>
                        <br />
                        Anticipo: <strong> {{ dataSessionInfo?.package.advancePayment | currency: 'MXN' }} </strong>
                        <br />
                        Restante a cubrir: <strong> {{ dataSessionInfo?.package.remainingTotal | currency: 'MXN' }} </strong>
                        <br />
                        <div class="text-danger" *ngIf="!dataSessionInfo?.remaining">
                            No hay pagos pendientes
                        </div>
                        <div *ngIf="dataSessionInfo?.remaining">
                            <strong> Fecha de los pagos: </strong>
                            <div class="ms-3" *ngFor="let payments of dataSessionInfo?.remaining">
                                <strong> Pago {{ payments.session_number }} </strong>
                                {{ payments.payment | currency: 'MXN' }}
                            </div>
                        </div>
                        Descuento: <strong> {{ dataSessionInfo?.package.percentage }}% </strong>
                        <br />
                        Numero de sesiones: <strong> {{ dataSessionInfo?.package.totalSessionNumber }} </strong>
                        <br />
                        Paquete Compartido: 
                        <strong>
                            <span *ngIf="!dataSessionInfo?.shared"> No </span>
                            <span *ngIf="dataSessionInfo?.shared"> Si </span>
                        </strong>
                        <br />
                        Observaciones del paquete: <strong> {{ dataSessionInfo?.package.observations }} </strong>
                    </div>

                    <table class="table table-striped">
                        <thead class="table-dark">
                            <tr>
                                <th> Area </th>
                                <th> Duraci&oacute;n </th>
                                <th> Total de sesiones </th>
                                <th> Sesiones tomadas </th>
                                <th> Sesiones restantes </th>
                                <th> Area terminada </th>
                                <th *ngIf="dataSessionInfo?.shared"> Cliente </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let area of dataSessionInfo?.areas">
                            <tr>
                                <td> {{ area.name }} </td>
                                <td> {{ area.duration }} </td>
                                <td> {{ area.total }} </td>
                                <td> {{ area.remaining }} </td>
                                <td> {{ area.pending }} </td>
                                <td> {{ area.finished }} </td>
                                <td *ngIf="dataSessionInfo?.shared"> {{ area.user_shared }} </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- informacion del paquete ** end ** -->

            <!-- Informacion de pagos ** start ** -->
            <div class="card mb-1" *ngIf="dataSessionInfo?.typeSession === 1">
                <div class="card-body">
                    <h5 class="card-title"> Informacion de pagos </h5>
                    <table class="table table-striped">
                        <thead class="table-drak">
                            <tr>
                                <th> Numero de sesi&oacute;n </th>
                                <th> Pago requerido al cliente ($) </th>
                                <th> Status del pago </th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let payment of dataSessionInfo?.payments; let index = index">
                            <tr [ngStyle]="{
                                'background-color':
                                    payment.payment > 0 &&
                                    dataSessionInfo?.numberSession == payment.sessionNumber
                                    ? '#E0B0FF'
                                    : ''
                            }">
                                <td> {{ payment.session_number }} </td>
                                <td> {{ payment.payment_original | currency: 'MXN' }} </td>
                                <td> {{ payment.is_paid ? 'Pagado' : 'No Pagado' }} </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <hr />
                <div class="card-body">
                    <h5 class="card-title"> Pagos realizados </h5>
                    <div class="alert alert-danger mt-2" *ngIf="dataSessionInfo?.payed.length === 0">
                        Por el momento, no hay pagos registrados para este paquete!
                    </div>
                    <table class="table table-striped" *ngIf="dataSessionInfo?.payed.lenght !== 0">
                        <thead class="table-dark">
                            <tr>
                                <th>Sesi&oacute;n</th>
                                <th>Cantidad</th>
                                <th>Metodo de pago</th>
                                <th>Tipo de pago</th>
                                <th>Terminal</th>
                                <th>Comentarios</th>
                                <th>Fecha</th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let payed of dataSessionInfo?.payed">
                            <tr>
                                <td>{{ payed.session }}</td>
                                <td>{{ payed.amount }}</td>
                                <td>{{ payed.payment_method }}</td>
                                <td>{{ payed.payment }}</td>
                                <td>{{ payed.terminal }}</td>
                                <td>{{ payed.extra }}</td>
                                <td>{{ payed.filter }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- Informacion de pagos ** end ** -->
            
            <!-- Areas trabajadas ** start ** -->
            <div class="card mb-1" *ngIf="areasWorkedFlag && dataSessionInfo?.typeSession === 1">
                <div class="card-body">
                    <h5 class="card-title"> Areas trabajadas en la sesi&oacute;n </h5>
                    <table class="table table-striped">
                        <thead class="table-dark">
                            <tr>
                                <th>ID</th>
                                <th>Area</th>
                                <th>Sesion</th>
                                <th>Cita</th>
                                <th>Trabajada</th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let areaWorked of dataSessionInfo?.areasWorked">
                            <tr>
                                <td>{{ areaWorked.id }}</td>
                                <td>{{ areaWorked.areas_name }}</td>
                                <td>{{ areaWorked.session_id }}</td>
                                <td>{{ areaWorked.appoinment_id }}</td>
                                <td>{{ areaWorked.is_completed ? "Si" : "No" }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- Areas trabajadas ** end ** -->

            <!-- Comentarios de la sesion ** start ** -->
            <div class="card mb-1">
                <div class="card-body">
                    <h5 class="card-title" *ngIf="dataSessionInfo?.typeSession === 1"> Comentarios de las sesiones </h5>
                    <h5 class="card-title" *ngIf="dataSessionInfo?.typeSession === 2"> Comentatios de las sesiones de valoraci&oacute;n </h5>
                    <table class="table table-striped">
                        <thead class="table-dark">
                            <tr>
                                <th *ngIf="dataSessionInfo?.typeSession === 1"># de sesi&oacute;n</th>
                                <th>Situaciones con las citas</th>
                                <th>Fecha de situaciones con las citas</th>
                                <th>Comentatios de cabina</th>
                                <th *ngIf="dataSessionInfo?.typeSession === 1">Fecha del comentario de cabina</th>
                                <th *ngIf="dataSessionInfo?.typeSession === 2">Fecha del comentario de cabina (Valoraci&oacute;n)</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="dataSessionInfo?.typeSession === 2">
                            <tr>
                                <td>{{ dataSessionInfo?.comments }}</td>
                                <td>{{ dataSessionInfo?.created }}</td>
                                <td>{{ dataSessionInfo?.finalComments }}</td>
                                <td>{{ dataSessionInfo?.updated }}</td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="dataSessionInfo?.typeSessions === 1">
                            <tr *ngFor="let comment of dataSessionInfo?.commentsSessions">
                                <td>{{ comment.numberSession }}</td>
                                <td>{{ comment.comments }}</td>
                                <td>{{ comment.dateCreated }}</td>
                                <td>{{ comment.finalComments }}</td>
                                <td>{{ comment.dateUpdated }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- Comentarios de la sesion ** end ** -->
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="close()">
            Cerrar
        </button>
    </div>
</ng-template>
<!-- Information about session ** start ** -->

<!-- Create session ** start ** -->
<ng-template #createSession let-close="close">
    <div class="modal-header">
        <h5 class="modal-title"> {{ dynamicMessage }} </h5>
        <button type="button" (click)="close()" class="close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <!-- Crear radios para abrir formularios ** start ** -->
    <div class="ms-2 mt-1 mb-1" style="margin-left: 15px !important;">
        <div class="form-check-inline" *ngFor="let types of typePackagesAvailable">
            <input type="radio" name="sessionType" id="sessionType7" class="form-check-input"
                (change)="showForms($event)" value="{{ types.type_package }}">
            <label for="sessionType7" class="form-check-label ms-1">
                Sesi&oacute;n de {{ types.description.toLowerCase() }}
            </label>
        </div>

        <div class="form-check-inline">
            <input type="radio" name="sessionType" id="sessionType2" class="form-check-input"
                (change)="showForms($event)" value="2">
            <label for="sessionType2" class="form-check-label ms-1">
                Sesi&oacute;n de depilaci&oacute;n por &aacute;rea
            </label>
        </div>

        <div class="form-check-inline">
            <input type="radio" name="sessionType" id="sessionType1" class="form-check-input"
                (change)="showForms($event)" value="10" />
            <label for="sessionType1" class="form-check-label ms-1">
                Sesi&oacute;n de valoraci&oacute;n
            </label>
        </div>

        <div class="form-check-inline">
            <input type="radio" name="sessionType" id="sessionType3" class="form-check-input"
                (change)="showForms($event)" value="11">
            <label for="sessionType3" class="form-check-label ms-1">
                Junta
            </label>
        </div>
    </div>
    <!-- Crear radios para abrir formularios ** end ** -->
    <hr />
    <!-- Formulario de valoracion ** start ** --><!-- 1 -->
    <div *ngIf="flagTypeSession === 10">
        <div class="alert alert-danger mt-2 ms-2 me-2" role="alert" *ngIf="disabledNewSession">
            {{ messageNewSession }}
        </div>
        <div class="alert alert-danger mt-2 ms-2 me-2" role="alert" *ngIf="flagValueZero">
            {{ messageZero }}
        </div>
        
        <div class="modal-body">
            <form [formGroup]="apptValorationForm" (ngSubmit)="sessionValoration()" novalidate>
                <input type="hidden" name="officeIdValue" formControlName="officeIdValue" />
                <input type="hidden" name="apptIdValue" formControlName="apptIdValue" />
                <input type="hidden" name="cabinIdValue" formControlName="cabinIdValue" />
                <input type="hidden" name="cabinNumberValue" formControlName="cabinNumberValue" />

                <div class="row">
                    <div class="form-floating mb-2">
                        <select name="typeUser" id="typeUser" formControlName="typeUser" class="form-select"
                            aria-label="Floating label select" (change)="typeUserForm($event)">
                                <option value="" selected>Seleccione una opcion</option>
                                <option value="1">Cliente registrado</option>
                                <option value="2">Cliente no registrado</option>
                        </select>
                        <label for="typeUser" class="ms-2"> Seleccione una opcion </label>
                    </div>
                </div>

                <div class="row mt-2" *ngIf="flagTypeClient === 1">
                    <input type="hidden" name="clientIdValue" id="clientIdValue" formControlName="clientIdValue" required />
                    <select2 [data]="clientsFilter" displaySearchStatus="always" style="width: 100%"
                        placeholder="Clientes" resettable listPosition="below" styleMode="material"
                        noResultMessage="Cliente no encontrado"
                        (update)="updateClientValoration($event)"
                        [ngClass]="{
                            'is-invalid': submitValoration && apptValorationFormFn.clientIdValue.errors,
                            'is-valid': submitValoration && !apptValorationFormFn.clientIdValue.errors
                        }"></select2>
                </div>

                <div class="row mt-2" *ngIf="flagTypeClient === 2">
                    <div class="form-floating mb-2">
                        <input type="text" name="nameNoClient" id="nameNoClient" formControlName="nameNoClient"
                            class="form-control" placeholder="Nombre del cliente" required
                            [ngClass]="{
                                'is-invalid': submitValoration && apptValorationFormFn.nameNoClient.errors,
                                'is-valid': submitValoration && !apptValorationFormFn.nameNoClient.errors
                            }">
                        <label for="nameNoClient" class="ms-2"> Nombre del cliente </label>
                    </div>
                </div>

                <div class="row">
                    <div class="form-floating mb-3 col-md-6">
                        <input type="hidden" name="employeeIdValue" id="employeeIdValue" formControlName="employeeIdValue" />
                        <select name="employeeIdValueTemp" id="employeeIdValueTemp" formControlName="employeeIdValueTemp" 
                            class="form-control" required
                            [ngClass]="{
                                'is-valid': submitValoration && !apptValorationFormFn.employeeIdValue.errors,
                                'is-invalid': submitValoration && apptValorationFormFn.employeeIdValue.errors
                            }">
                                <option value="" selected> Seleccione un colaborador </option>
                                <option value="{{ employee.id }}" *ngFor="let employee of employees">
                                    {{ employee.first_name }} {{ employee.last_name }} ({{ employee.email }})
                                </option>
                        </select>
                        <label for="employeeIdValueTemp" class="ms-2"> Selecciona un colaborador </label>
                    </div>
                    
                    <div class="form-floating col-md-6 mb-3">
                        <div class="input-group">
                            <input type="text" name="dateSessionValue" class="form-control" id="dateSessionValue" formControlName="dateSessionValue"
                                placeholder="Fecha de inicio de sesion" ngbDatepicker #d="ngbDatepicker" required readonly style="height: 3.5rem"
                                [ngClass]="{
                                    'is-valid': submitAppt && !apptExistsFn.dateSessionValue.errors,
                                    'is-invalid': submitAppt && apptExistsFn.dateSessionValue.errors
                                }" />
                            <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()" type="button"></button>
                            <div *ngIf="apptValorationFormFn.dateSessionValue?.errors && apptValorationFormFn.dateSessionValue?.invalid && submitExists">
                                <div class="text-danger" *ngIf="apptValorationFormFn.dateSessionValue?.errors.required">
                                    Por favor, selecciona una fecha de sesion.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-4">
                    <div class="col-md-3 offset-md-2">
                        <label for="startSession"> Hora de inicio </label>
                        <ngb-timepicker
                            [(ngModel)]="startSession"
                            [ngModelOptions]="{ standalone: true }"
                            [spinners]="true"
                            (ngModelChange)="changeHour(false)"></ngb-timepicker>
                    </div>
                    <div class="col-md-3 offset-md-2">
                        <label for="endSession"> Hora de fin </label>
                        <ngb-timepicker
                            [(ngModel)]="endSession"
                            [ngModelOptions]="{ standalone: true }"
                            [readonlyInputs]="true"></ngb-timepicker>

                        <div class="text-danger" *ngIf="submitExists && flagEndTimeValidation">
                            Por favor, selecciona una hora de termino de sesion.
                        </div>
                    </div>
                </div>

                <div class="input-group mb-3">
                    <span class="input-group-text"> Comentarios </span>
                    <textarea name="commentsValue" id="commentsValue" class="form-control" formControlName="commentsValue"
                        aria-label="Comentarios" 
                        [ngClass]="{
                            'is-invalid': submitValoration && apptValorationFormFn.commentsValue.errors,
                            'is-valid': submitValoration && !apptValorationFormFn.commentsValue.errors
                        }"></textarea>
                </div>

                <div class="row">
                    <div class="d-grip gap-2 d-md-flex justify-content-md-end">
                        <button type="submit" [disabled]="disabledButtons" class="btn btn-outline-success">
                            Agendar valoraci&oacute;n
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <!-- Formulario de valoracion ** end ** -->

    <!-- Sesiones de depilacion ** start ** -->
    <div *ngIf="flagTypeSession === 1"> <!-- 7 -->
        <div class="alert alert-danger mt-2 ms-2 me-2" role="alert" *ngIf="disabledNewSession">
            {{ messageNewSession }}
        </div>
        <div class="alert alert-danger mt-2 ms-2 me-2" role="alert" *ngIf="flagSessionActive">
            La sesi&oacute;n abarca hora de descanso del colaborador. Por favor cambie la hora de la sesi&oacute;n.
        </div>

        <div class="alert alert-danger ms-2 mt-2 me-2" role="alert" *ngIf="showScheduleSession === 2">
            No hay paquetes activos para el cliente seleccionado.
        </div>
        
        <div class="modal-body">
            <form [formGroup]="apptExistsV1" (ngSubmit)="appointmentsV1()" novalidate>
                <input type="hidden" name="cabinId" id="cabinId" formControlName="cabinId" />
                <input type="hidden" name="cabinNumber" id="cabinNumber" formControlName="cabinNumber" />

                <div class="row">
                    <div class="form-floating col-md-12">
                        <input type="hidden" name="clientId" id="clientId" formControlName="clientId" />
                        <select2 [data]="clientsFilter" displaySearchStatus="always" style="width: 100%"
                            placeholder="Clientes" resettable listPosition="below" styleMode="material" 
                            noResultMessage="Cliente no encontrado"
                            (update)="updateClientPackageV1($event)"
                            [ngClass]="{
                                'is-invalid': submitApptV1 && apptExistsV1Fn.clientId.errors,
                                'is-valid': submitApptV1 && !apptExistsV1Fn.clientId.errors
                            }"></select2>
                    </div>
                </div>
                
                <div class="row">
                    <div class="form-floating mb-3 col-md-12" *ngIf="flagClientOpen">
                        <input type="hidden" name="packageId" id="packageId" formControlName="packageId" required />

                        <select2 [data]="packageFilter" displaySearchStatus="always" style="width: 100%"
                            placeholder="Paquetes" multiple hideSelectedItems listPosition="below" styleMode="material"
                            noResultMessage="Paquete no encontrado" (update)="loadInformationExistsV1($event)"></select2>
                    </div>
                </div>

                <div class="row">
                    <div class="form-floating mb-3 col-md-6">
                        <input type="hidden" name="employeeId" id="employeeId" formControlName="employeeId" />

                        <select name="employeeId" id="employeeId" class="form-control" 
                            formControlName="employeeIdTemp" required
                            [ngClass]="{
                                'is-valid': submitApptV1 && !apptExistsV1Fn.employeeId.errors,
                                'is-invalid': submitApptV1 && apptExistsV1Fn.employeeId.errors
                            }">
                                <option value=""> Selecciona un colaborador </option>
                                <option value="{{ employee.id }}" *ngFor="let employee of employees">
                                    {{ employee.first_name }} {{ employee.last_name }} ({{ employee.email }})
                                </option>
                        </select>
                        <label for="employeeId" class="ms-2"> Selecciona un colaborador </label>
                    </div>

                    <div class="form-floating col-md-6">
                        <div class="input-group">
                            <input type="text" name="dateSession" class="form-control" id="dateSession"
                                formControlName="dateSession" placeholder="Fecha de inicio de sesion" ngbDatepicker
                                #d="ngbDatepicker" required readonly style="height: 3.5rem;"
                                [ngClass]="{
                                    'is-valid': submitApptV1 && !apptExistsV1Fn.dateSession.errors,
                                    'is-invalid': submitApptV1 && apptExistsV1Fn.dateSession.errors
                                }">
                            <button class="btn btn-outline-secondary bi bi-calendar3" type="button" (click)="d.toggle()">
                            </button>
                            <div *ngIf="apptExistsV1Fn.dateSession?.errors && apptExistsV1Fn.dateSession?.invalid && submitApptV1">
                                <div class="text-danger" *ngIf="apptExistsV1Fn.dateSession.errors.required">
                                    Por favor, selecciona una fecha de sesi&oacute;n.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-3 offset-md-2">
                        <label for="startSession"> Hora de inicio </label>
                        <ngb-timepicker [(ngModel)]="startSession" [ngModelOptions]="{ standalone: true }"></ngb-timepicker>
                    </div>

                    <div class="col-md-3 offset-md-2">
                        <label for="endSession"> Hora de fin </label>
                        <ngb-timepicker [(ngModel)]="endSession" [ngModelOptions]="{ standalone: true }" [minuteStep]="step"></ngb-timepicker>
                        <div class="text-danger" *ngIf="submitApptV1 && (endSession.hour === '' || endSession.minute === '')">
                            Por favor, selecciona una hora de termino de sesi&oacute;n.
                        </div>
                    </div>
                </div>

                <div class="input-group mb-3">
                    <span class="input-group-text"> Comentarios </span>
                    <textarea name="comments" id="comments" formControlName="comments" class="form-control"
                        aria-label="Comentarios" [ngClass]="{
                            'is-invalid': submitApptV1 && apptExistsV1Fn.comments.errors,
                            'is-valid': submitApptV1 && !apptExistsV1Fn.comments.errors
                        }"></textarea>
                </div>

                <div class="row">
                    <div class="d-grip gap-2 d-md-flex justify-content-md-end">
                        <button type="submit" class="btn btn-outline-success" [disabled]="!disabledScheduleButton">
                            Agendar sesi&oacute;n
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <!-- Sesiones de depilacion ** end ** -->

    <!-- Sesiones programadas ** start ** -->
    <div *ngIf="flagTypeSession === 2">
        <div class="alert alert-danger mt-2 ms-2 me-2" role="alert" *ngIf="disabledNewSession">
            {{ messageNewSession }}
        </div>

        <div class="alert alert-danger mt-2 ms-2 me-2" role="alert" *ngIf="flagSessionActive">
            La sesi&oacute;n abarca hora de descanso del colaborador. Por favor cambie la hora de la sesi&oacute;n.
        </div>

        <div class="alert alert-danger mt-2 ms-2 me-2" role="alert" *ngIf="showScheduleSession === 2">
            No hay paquetes activos para el cliente seleccionado.
        </div>
        
        <div class="modal-body">                                                
            <form [formGroup]="apptExists" (ngSubmit)="existsAppointments()" novalidate>
                <input type="hidden" name="officeId" id="officeId" formControlName="officeId" />
                <input type="hidden" name="apptId" id="apptId" formControlName="apptId" />
                <input type="hidden" name="cabinId" id="cabinId" formControlName="cabinId" />
                <input type="hidden" name="cabinNumber" id="cabinNumber" formControlName="cabinNumber" />
                <div class="row">
                    <div class="form-floating col-md-{{ clientColSize }}">
                        <input type="hidden" name="clientId" id="clientId" formControlName="clientId" />

                        <select2 [data]="clientsFilter" displaySearchStatus="always" style="width: 100%" 
                            placeholder="Clientes" resettable listPosition="below" styleMode="material" 
                            noResultMessage="Cliente no encontrado" (update)="updateClientPackage($event, 5)"
                            [ngClass]="{
                                'is-invalid': submitAppt && apptExistsFn.clientId.errors,
                                'is-valid': submitAppt && !apptExistsFn.clientId.errors
                            }"></select2>
                    </div>
                    <div class="form-floating col-md-6 mb-3" *ngIf="flagClientOpen">
                        <select name="packageId" id="packageId" class="form-control" formControlName="packageId"
                            required (change)="loadInformationExists($event)"
                            [ngClass]="{
                                'is-valid': submitAppt && !apptExistsFn.packageId.errors,
                                'is-invalid': submitAppt && apptExistsFn.packageId.errors
                            }">
                                <option value="" selected> Selecciona un paquete </option>
                                <option value="{{ package.id }}" *ngFor="let package of packageFilter">
                                    {{ package.type }} {{ package.packageShared }} ({{ package.packageName }} - {{ package.sessionNumber }} sesiones)
                                </option>
                        </select>
                        <label for="packageId" class="ms-2"> Paquetes </label>
                    </div>
                </div>

                <div *ngIf="showScheduleSession === 1">
                    <div class="row mb-2">
                        <div class="form-check ms-2">
                            <input type="radio" class="form-check-input" id="type1" name="type" value="1" 
                                formControlName="type"
                                (change)="isEnabledCustomAreas($event)" />
                            <label for="type1" class="form-check-label"> Sesi&oacute;n complete </label>
                        </div>

                        <div class="form-check ms-2">
                            <input type="radio" name="type" class="form-check-input" id="type2"
                                formControlName="type" value="0"
                                (change)="isEnabledCustomAreas($event)" />
                            <label for="type2" class="form-check-label"> Sesi&oacute;n parcial </label>
                        </div>
                        <div *ngIf="submitAppt && apptExistsFn.type?.errors && apptExistsFn.type?.invalid">
                            <div class="text-danger"></div>
                        </div>
                    </div>

                    <div *ngIf="showTables">
                        <fieldset class="border p-3 mt-2 mb-4">
                            <div class="row" *ngIf="flagSimpleArea">
                                <div class="col-md-4 mb-2" *ngFor="let areaPackage of areasPackageSelected">
                                    <input type="checkbox" class="form-check-input" (change)="storeAreaSelected($event, areaPackage.sess_id)" />
                                    <label for="areaPackage">{{ areaPackage.area }}</label>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    <div class="row">
                        <div class="form-floating mb-3 col-md-6">
                            <input type="hidden" name="employeeId" id="employeeId" formControlName="employeeId" />

                            <select name="employeeId" id="employeeId" class="form-control"
                                formControlName="employeeId" required
                                [ngClass]="{
                                    'is-valid': submitAppt && !apptExistsFn.employeeId.errors,
                                    'is-invalid': submitAppt && apptExistsFn.employeeId.errors
                                }">
                                    <option value="" selected> Selecciona un colaborador </option>
                                    <option value="{{ employee.id }}" *ngFor="let employee of employees">
                                        {{ employee.first_name }} {{ employee.last_name }} ({{ employee.email }})
                                    </option>
                            </select>
                            <label for="employeeId" class="ms-2"> Selecciona un colaborador </label>
                        </div>
                        <div class="col-md-6 mb-3 form-floating">
                            <input type="text" name="totalSessions" id="totalSessions" formControlName="totalSessions"
                                class="form-control" placeholder="Total de sesiones restantes del paquete" required readonly
                                [ngClass]="{
                                    'is-valid': submitAppt && !apptExistsFn.totalSessions.errors,
                                    'is-invalid': submitAppt && apptExistsFn.totalSessions.errors
                                }" />
                            <label for="totalSessions" class="ms-2">
                                Total de sesiones restantes del paquete
                            </label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6 mb-3 form-floating">
                            <div class="input-group">
                                <input type="text" class="form-control" id="dateSession" class="form-control" 
                                    formControlName="dateSession" placeholder="Fecha de inicio de sesion" ngbDatepicker
                                    #d="ngbDatepicker" required readonly style="height: 3.5rem"
                                    ngClass]="{
                                        'is-valid': submitAppt && !apptExistsFn.dateSession.errors,
                                        'is-invalid': submitAppt && apptExistsFn.dateSession.errors
                                    }">
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()" type="button"></button>
                                <div *ngIf="apptExistsFn.dateSession?.errors && apptExistsFn.dateSession?.invalid && submitAppt">
                                    <div class="text-danger" *ngIf="apptExistsFn.dateSession.errors.required"> 
                                        Por favor, seleccione una fecha de sesi&oacute;n 
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 mb-3 form-floating">
                            <input type="text" class="form-control" id="sessionNumber" name="sessionNumber" formControlName="sessionNumber"
                                placeholder="Numero de sesiones" required
                                [ngClass]="{
                                    'is-valid': submitAppt && !apptExistsFn.sessionNumber.errors,
                                    'is-invalid': submitAppt && apptExistsFn.sessionNumber.errors
                                }" />
                            <label for="sessionNumber" class="ms-2"> Numero de sesi&oacute;n </label>
                            <div *ngIf="apptExistsFn.sessionNumber?.errors && apptExistsFn.sessionNumber?.invalid && submitAppt">
                                <div class="text-danger" *ngIf="apptExistsFn.sessionNumber.errors.required">
                                    Por favor, selecciona una cita para establecer el numero de sesi&oacute;n.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4 offset-md-2">
                            <label for="startSession"> Hora de inicio </label>
                            <ngb-timepicker [(ngModel)]="startSession" [ngModelOptions]="{ standalone: true }"></ngb-timepicker>
                        </div>

                        <div class="col-md-4 mb-2">
                            <label for="endSession"> Hora de fin </label>
                            <ngb-timepicker [(ngModel)]="endSession" [ngModelOptions]="{ standalone: true }" [minuteStep]="step"></ngb-timepicker>
                            <div class="text-danger" *ngIf="submitAppt && (endSession.hour === '' || endSession.minute === '')">
                                Por favor, selecciona una hora de termino de sesi&oacute;n.
                            </div>
                        </div>
                    </div>

                    <div class="input-group mb-3">
                        <span class="input-group-text"> Comentarios </span>
                        <textarea name="comments" id="comments" class="form-control" formControlName="comments" aria-label="Comentarios"
                            [ngClass]="{
                                'is-invalid': submitAppt && apptExistsFn.comments.errors,
                                'is-valid': submitAppt && !apptExistsFn.comments.errors
                            }"></textarea>
                    </div>

                    <div class="row">
                        <div class="d-grip gap-2 d-md-flex justify-content-md-end">
                            <button class="btn btn-outline-success" type="submit" [disabled]="!disabledScheduleButton">
                                Agendar sesi&oacute;n
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <!-- Sesiones programadas ** end ** -->

    <!-- Sesiones de juventud eterna ** start ** --><!-- 5 -->
    <div *ngIf="flagTypeSession === 6">
        <div class="alert alert-danger mt-2 ms-2 me-2" role="alert" *ngIf="disabledNewSession">
            {{ messageNewSession }}
        </div>
        <div class="alert alert-danger mt-2 ms-2 me-2" role="alert" *ngIf="flagSessionActive">
            La sesi&oacute;n abarca hora de descanso del colaborador. Por favor cambie la hora de la sesi&oacute;n.
        </div>
        <div class="alert alert-danger mt-2 ms-2 me-2" role="alert" *ngIf="showScheduleSession === 2"> 
            No hay paquetes activos para el cliente seleccionado.
        </div>
        
        <div class="modal-body">
            <form [formGroup]="apptExists" (ngSubmit)="existsAppointments()" novalidate>
                <input type="hidden" name="officeId" formControlName="officeId" id="officeId" />
                <input type="hidden" name="cabinId" formControlName="cabinId" id="cabinId" />
                <input type="hidden" name="cabinNumber" formControlName="cabinNumber" id="cabinNumber" />
                <input type="hidden" name="apptId" formControlName="apptId" id="apptId" />

                <div class="row">
                    <div class="form-floating col-md-{{ clientColSize }}">
                        <input type="hidden" name="ClientId" id="clientId" formControlName="clientId" required />
                        <select2
                        [data]="clientsFilter"
                        displaySearchStatus="always"
                        style="width: 100%"
                        placeholder="Clientes"
                        resettable
                        listPosition="below"
                        styleMode="material"
                        noResultMessage="Cliente no encontrado"
                        (update)="updateClientPackage($event)"
                        [ngClass]="{
                            'is-invalid': submitAppt && apptExistsFn.clientId.errors,
                            'is-valid': submitAppt && !apptExistsFn.clientId.errors
                        }"></select2>
                    </div>

                    <div class="form-floating mb-3 col-md-6" *ngIf="flagClientOpen">
                        <select name="packageId" id="packageId" class="form-control" formControlName="packageId"
                            required (change)="loadInformationExists($event)"
                            [ngClass]="{
                                'is-valid': submitAppt && !apptExistsFn.packageId.errors,
                                'is-invalid': submitAppt && apptExistsFn.packageId.errors
                            }">
                                <option value="" selected> Selecciona un paquete </option>
                                <option value="{{ package.id }}" *ngFor="let package of packageFilter">
                                    {{ package.type }} {{ package.packageShared }} ({{ package.packageName }} - {{ package.sessionNumber }} sesiones)
                                </option>
                        </select>
                        <label for="packageId" class="ms-2"> Selecciona un paquete </label>
                    </div>
                </div>

                <div *ngIf="showScheduleSession === 1">
                    <div class="row mb-2">
                        <div class="form-check ms-2">
                            <input type="radio" class="form-check-input" id="type1" name="type" value="1"
                                formControlName="type" [checked]="true" checked (change)="isEnabledCustomAreas($event)" />
                            <label for="type1" class="form-check-label"> Sesi&oacute;n completa </label>
                        </div>
                        <div class="form-check ms-2">
                            <input type="radio" class="form-check-input" id="type2" name="type" value="0"
                                formControlName="type" (change)="isEnabledCustomAreas($event)" />
                            <label for="type2" class="form-check-label"> Sesi&oacute;n parcial </label>
                        </div>
                        <div *ngIf="apptExistsFn.type?.errors && apptExistsFn.type?.invalid && submitAppt">
                            <div class="text-danger" *ngIf="apptExistsFn.type.errors.required">
                                Seleccione un tipo de sesi&oacute;n
                            </div>
                        </div>
                    </div>

                    <div class="row mb-2" *ngIf="showTables">
                        <div class="col-md-12">
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="flagCustom" formControlName="flagCustom"
                                    (change)="showHideSimpleAreas($event)" />
                                <label for="select_areas" class="form-check-label">
                                    Selecciona areas especificas
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="row" *ngIf="flagSimpleArea">
                        <div class="col-md-4 mb-2" *ngFor="let areasSelected of areasPackageSelected">
                            <input type="checkbox" class="form-check-input" (change)="storeAreaSelected($event, areasSelected.sess_id)" />
                            <label for="areasSelected"> {{ areasSelected.area }} </label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-floating mb-3 col-md-6">
                            <input type="hidden" name="employeeId" id="employeeId" formControlName="employeeId" />

                            <select name="employeeId" id="employeeId" class="form-control" formControlName="employeeIdTemp" required
                            [ngClass]="{
                                'is-valid': submitAppt && !apptExistsFn.employeeId.errors,
                                'is-invalid': submitAppt && apptExistsFn.employeeId.errors
                            }">
                                <option value="" selected> Selecciona un colaborador </option>
                                <option value="{{ employee.id }}" *ngFor="let employee of employees">
                                    {{ employee.first_name }} {{ employee.last_name }} ({{ employee.email }})
                                </option>
                            </select>
                            <label for="employeeId" class="ms-2"> Selecciona un colaborador </label>
                        </div>

                        <div class="form-floating mb-3 col-md-6">
                            <input type="text" class="form-control" id="totalSessions" name="totalSessions" formControlName="totalSessions"
                                placeholder="Total de sesiones restantes del paquete" required readonly
                                [ngClass]="{
                                    'is-valid': submitAppt && !apptExistsFn.totalSessions.errors,
                                    'is-invalid': submitAppt && apptExistsFn.totalSessions.errors
                                }" />
                            <label for="totalSessions" class="ms-2"> Total de sesiones restantes del paquete </label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6 mb-3 form-floating">
                            <div class="input-group">
                                <input type="text" name="dateSession" class="form-control" id="dateSession" formControlName="dateSession"
                                    placeholder="Fecha de inicio de sesion" ngbDatepicker #d="ngbDatepicker" required readonly style="height: 3.5rem"
                                    [ngClass]="{
                                        'is-valid': submitAppt && !apptExistsFn.dateSession.errors,
                                        'is-invalid': submitAppt && apptExistsFn.dateSession.errors
                                    }" />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()" type="button"></button>
                                <div *ngIf="apptExistsFn.dateSession?.errors && apptExistsFn.dateSession?.invalid && submitAppt">
                                    <div class="text-danger" *ngIf="apptExistsFn.dateSession?.errors.required">
                                        Por favor, seleccione una fecha de sesi&oacute;n
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 mb-3 form-floating">
                            <input type="text" name="sessionNumber" class="form-control" id="sessionNumber" 
                                formControlName="sessionNumber" required
                                [ngClass]="{
                                    'is-valid': submitAppt && !apptExistsFn.sessionNumber.errors,
                                    'is-invalid': submitAppt && apptExistsFn.sessionNumber.errors
                                }" />
                            <label for="sessionNumber" class="ms-2"> Numero de sesi&oacute;n </label>
                            <div *ngIf="apptExistsFn.sessionNumber?.errors && apptExistsFn.sessionNumber?.invalid && submitAppt">
                                <div class="text-danger" *ngIf="apptExistsFn.sessionNumber?.errors.required">
                                    Por favor, selecciona una cita para establecer el numero de sesi&oacute;n.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3 offset-md-2">
                            <label for="startSession"> Hora de inicio </label>
                            <ngb-timepicker [(ngModel)]="startSession" [ngModelOptions]="{ standalone: true }"></ngb-timepicker>
                        </div>

                        <div class="col-md-3 offset-md-2">
                            <label for="endSession"> Hora de fin </label>
                            <ngb-timepicker [(ngModel)]="endSession" [ngModelOptions]="{ standalone: true }" [minuteStep]="step"></ngb-timepicker>
                            <div class="text-danger" *ngIf="submitAppt && (endSession.hour === '' || endSession.minute === '')">
                                Por favor, selecciona una hora de termino de sesi&oacute;n.
                            </div>
                        </div>
                    </div>

                    <div class="input-group mb-3">
                        <span class="input-group-text"> Comentarios </span>
                        <textarea name="comments" id="comments" class="form-control"
                            formControlName="comments" aria-label="Comentarios"
                            [ngClass]="{
                                'is-invalid': submitAppt && apptExistsFn.comments.errors,
                                'is-valid': submitAppt && !apptExistsFn.comments.errors
                            }"></textarea>
                    </div>

                    <div class="row">
                        <div class="d-grip gap-2 d-md-flex justify-content-md-end">
                            <button class="btn btn-outline-success" [disabled]="!disabledScheduleButton">
                                Agendar sesi&oacute;n hidrafacial
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <!-- Sesiones de juventud eterna ** end ** -->

    <!-- Session de hidrafacial ** start ** --><!-- 6 -->
    <div *ngIf="flagTypeSession === 4">
        <div class="alert alert-danger mt-2 ms-2 me-2" role="alert" *ngIf="disabledNewSession">
            {{ messageNewSession }}
        </div>

        <div class="alert alert-danger mt-2 ms-2 me-2" role="alert" *ngIf="flagSessionActive">
            La sesi&oacute;n abarca hora de descanso del colaborador. Por favor cambie la hora de la sesi&oacute;n.
        </div>

        <div class="alert alert-danger mt-2 ms-2 me-2" role="alert" *ngIf="showScheduleSession === 2">
            No hay paquetes activos para el cliente seleccionado.
        </div>
    
        <div class="modal-body">
            <form [formGroup]="apptExists" (ngSubmit)="existsAppointments()" novalidate>
                <input type="hidden" name="officeId" id="officeId" formControlName="officeId" />
                <input type="hidden" name="apptId" id="apptId" formControlName="apptId" />
                <input type="hidden" name="cabinId" id="cabinId" formControlName="apptId" />
                <input type="hidden" name="cabinNumber" id="cabinNumber" formControlName="cabinNumber" />

                <div class="row">
                    <div class="form-floating col-md-{{ clientColSize }}">
                        <input type="hidden" name="clientId" id="clientId" formControlName="clientId" required />

                        <select2 [data]="clientsFilter" displaySearchStatus="always" style="width: 100%" placeholder="Clientes"
                            resettable listPosition="below" styleMode="material" noResultMessage="Cliente no encontrado" 
                            (update)="updateClientPackage($event, 4)"
                            [ngClass]="{
                                'is-invalid': submitAppt && apptExistsFn.clientId.errors,
                                'is-valid': submitAppt && !apptExistsFn.clientId.errors
                            }"
                            ></select2>
                    </div>

                    <div class="form-floating mb-3 col-md-6" *ngIf="flagClientOpen">
                        <select name="packageId" id="packageId" class="form-control" formControlName="packageId"
                            required (change)="loadInformationExists($event)"
                            [ngClass]="{
                                'is-valid': submitAppt && !apptExistsFn.packageId.errors,
                                'is-invalid': submitAppt && apptExistsFn.packageId.errors
                            }">
                                <option value="" selected> Seleccione un paquete </option>
                                <option value="{{ package.id }}" *ngFor="let package of packageFilter">
                                    {{ package.type }} {{ package.packageShared }} ({{ package.packageName }} - {{ package.sessionNumber }} sesiones)
                                </option>
                        </select>
                        <label for="packageId" class="ms-2"> Seleccione un paquete </label>
                    </div>
                </div>

                <div *ngIf="showScheduleSession === 1">
                    <div class="row mb-2">
                        <div class="form-check ms-2">
                            <input type="radio" class="form-check-input" id="type1" name="type" value="1" 
                                formControlName="type"
                                (change)="isEnabledCustomAreas($event)" />
                            <label for="type1" class="form-check-label"> Sesi&oacute;n complete </label>
                        </div>

                        <div class="form-check ms-2">
                            <input type="radio" name="type" class="form-check-input" id="type2"
                                formControlName="type" value="0"
                                (change)="isEnabledCustomAreas($event)" />
                            <label for="type2" class="form-check-label"> Sesi&oacute;n parcial </label>
                        </div>
                        <div *ngIf="submitAppt && apptExistsFn.type?.errors && apptExistsFn.type?.invalid">
                            <div class="text-danger"></div>
                        </div>
                    </div>

                    <div class="row mb-2" *ngIf="showTables">
                       <!--  <div class="col-md-12">
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="flagCustom" formControlName="flagCustom"
                                    (change)="showHideSimpleAreas($event)" />
                                <label for="flagAreas" class="form-check-label"> Selecciona areas especificas </label>
                            </div>
                        </div> -->
                        <fieldset class="border p-3 mt-2 mb-4">
                            <div class="row" *ngIf="flagSimpleArea">
                                <div class="col-md-4 mb-2" *ngFor="let areas of areasPackageSelected">
                                    <input type="checkbox" class="form-check-input"
                                        (change)="storeAreaSelected($event, areas.sess_id)" />
                                    <label for="areas"> {{ areas.area }} </label>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    <div class="row">
                        <div class="col-md-6 mb-3 form-floating">
                            <input type="hidden" name="employeeId" id="employeeId" formControlName="employeeId" />

                            <select name="employeeId" id="employeeId" class="form-control" formControlName="employeeIdTemp" required
                                [ngClass]="{
                                    'is-valid': submitAppt && !apptExistsFn.employeeId.errors,
                                    'is-invalid': submitAppt && apptExistsFn.employeeId.errors
                                }">
                                    <option value="" selected> Selecciona un colaborador </option>
                                    <option value="{{ employee.id }}" *ngFor="let employee of employees">
                                        {{ employee.first_name }} {{ employee.last_name }} ({{ employee.email }})
                                    </option>
                            </select>
                            <label for="employeeId" class="ms-2">
                                Selecciona un colaborador
                            </label>
                        </div>

                        <div class="col-md-6 mb-3 form-floating">
                            <input type="text" name="totalSessions" id="totalSessions" class="form-control" 
                                formControlName="totalSessions" placeholder="Total de sesiones restantes del paquete"
                                required readonly
                                [ngClass]="{
                                    'is-valid': submitAppt && !apptExistsFn.totalSessions.errors,
                                    'is-invalid': submitAppt && apptExistsFn.totalSessions.errors
                                }" />
                            <label for="totalSessions" class="ms-1"> Total de sesiones restantes del paquete </label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6 mb-3 form-floating">
                            <div class="input-group">
                                <input type="text" class="form-control" id="dateSession" name="dateSession" formControlName="dateSession"
                                    placeholder="Fecha de inicio de sesi&oacute;n" ngbDatepicker #d="ngbDatepicker" required
                                    readonly style="height: 3.5rem"
                                    [ngClass]="{
                                        'is-valid': submitAppt && !apptExistsFn.dateSession.errors,
                                        'is-invalid': submitAppt && apptExistsFn.dateSession.errors
                                    }" />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()" type="button"></button>
                            </div>

                            <div *ngIf="apptExistsFn.dateSession?.errors && apptExistsFn.dateSession?.invalid && submitAppt">
                                <div class="text-danger" *ngIf="apptExistsFn.dateSession.errors.required">
                                    Por favor, selecciona una fecha de sesi&oacute;n
                                </div>
                            </div>                            
                        </div>

                        <div class="col-md-6 mb-3 form-floating">
                            <input type="text" class="form-control" id="sessionNumber" name="sessionNumber"
                                placeholder="Numero de sesi&oacute;n" required formControlName="sessionNumber"
                                [ngClass]="{
                                    'is-valid': submitAppt && !apptExistsFn.sessionNumber.errors,
                                    'is-invalid': submitAppt && apptExistsFn.sessionNumber.errors
                                }">
                            <label for="sessionNumber" class="ms-2"> Numero de sesi&oacute;n </label>

                            <div *ngIf="apptExistsFn.sessionNumber?.errors && apptExistsFn.sessionNumber?.invalid && submitAppt">
                                <div class="text-danger" *ngIf="apptExistsFn.sessionNumber?.errors.required">
                                    Por favor, selecciona una cita para despues establecer el numero de sesi&oacute;n
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-md-3 offset-md-2">
                            <label for="startSession"> Hora de inicio </label>
                            <ngb-timepicker [(ngModel)]="startSession" [ngModelOptions]="{ standalone: true }"></ngb-timepicker>
                        </div>

                        <div class="col-md-3 offset-md-2">
                            <label for="endSession"> Hora de fin </label>
                            <ngb-timepicker [(ngModel)]="endSession" [ngModelOptions]="{ standalone: true }" [minuteStep]="step"></ngb-timepicker>

                            <div class="text-danger" *ngIf="submitAppt && (endSession.hour === '' || endSession.minute === '')">
                                Por favor, selecciona la hora de terminaci&oacute;n de la sesi&oacute;n
                            </div>
                        </div>
                    </div>

                    <div class="input-group mb-3">
                        <span class="input-group-text"> Comentarios </span>
                        <textarea name="comments" id="comments" class="form-control" formControlName="comments" aria-label="Comentarios"
                            [ngClass]="{
                                'is-invalid': submitAppt && apptExistsFn.comments.errors,
                                'is-valid': submitAppt && !apptExistsFn.comments.errors
                            }"></textarea>
                    </div>

                    <div class="row">
                        <div class="d-grip gap-2 d-md-flex justify-content-md-end">
                            <button type="submit" class="btn btn-outline-success" [disabled]="!disabledScheduleButton">
                                Agendar sesi&oacute;n
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <!-- Session de hidrafacial ** end ** -->

    <!-- Agendar vacaciones ** start ** -->
    <div *ngIf="flagTypeSession === 3">
        <div class="modal-body">
            <form [formGroup]="vacationsForm" (ngSubmit)="scheduleVacations()" novalidate>
                <input type="hidden" name="officeId" id="officeId" formControlName="officeId" />
                <input type="hidden" name="cabinId" id="cabinId" formControlName="cabinId" />
                <input type="hidden" name="employeeId" id="employeeId" formControlName="employeeId" />

                <div class="row">
                    <select2 [data]="filterEmployees" displaySearchStatus="always" style="width: 100%" placeholder="Colaboradores"
                        resettable listPosition="below" styleMode="material" noResultMessage="Colaborador no encontrado" 
                        (update)="updateClientsVacations($event)" 
                        [ngClass]="{
                            'is-invalid': submitVacations && vacationsFormFn.temporalEmployeeId.errors,
                            'is-valid': submitVacations && !vacationsFormFn.temporalEmployeeId.errors
                        }"></select2>
                </div>

                <div class="row">
                    <div class="col-md-6 mb-3 form-floating">
                        <div class="input-group">
                            <input type="text" class="form-control" id="startDate" id="startDate" name="startDate"
                                formControlName="startDate" placeholder="Fecha de inicio de vacaciones"
                                ngbDatepicker #d="ngbDatepicker" required readonly style="height: 3.5rem"
                                [ngClass]="{
                                    'is-valid': submitVacations && !vacationsFormFn.startDate.errors,
                                    'is-invalid': submitVacations && vacationsFormFn.startDate.errors
                            }">
                            <button type="button" class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()"></button>
                            <div *ngIf="vacationsFormFn.startDate?.errors && vacationsFormFn.startDate?.invalid && submitVacations">
                                <div class="text-danger" *ngIf="vacationsFormFn.startDate?.errors?.required">
                                    Por favor, seleccione la fecha de inicio de vacaciones
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 mb-3 form-floating">
                        <div class="input-group">
                            <input type="text" class="form-control" id="endDate" name="endDate" formControlName="endDate"
                                placeholder="Fecha de fin de vacaciones" ngbDatepicker #d2="ngbDatepicker" required readonly style="height: 3.5rem"
                                [ngClass]="{
                                    'is-valid': submitVacations && !vacationsFormFn.endDate.errors,
                                    'is-invalid': submitVacations && vacationsFormFn.endDate.errors
                                }">
                            <button type="button" class="btn btn-outline-secondary bi bi-calendar3" (click)="d2.toggle()"></button>
                            <div *ngIf="vacationsFormFn.endDate?.errors && vacationsFormFn.endDate?.invalid && submitVacations">
                                <div class="text-danger" *ngIf="vacationsFormFn.endDate?.errors?.required">
                                    Por favor, seleccione la fecha de fin de vacaciones
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-3 offset-md-2">
                        <label for="startSession"> Hora de inicio </label>
                        <ngb-timepicker [(ngModel)]="startVacations" [ngModelOptions]="{ standalone: true }" [minuteStep]="step"></ngb-timepicker>
                    </div>

                    <div class="col-md-3 offset-md-2">
                        <label for="startSession"> Hora final </label>
                        <ngb-timepicker [(ngModel)]="endVacations" [ngModelOptions]="{ standalone: true }" [minuteStep]="step"></ngb-timepicker>
                    </div>
                </div>

                <div class="row">
                    <div class="d-grip gap-2 d-md-flex justify-content-md-end">
                        <button type="submit" class="btn btn-outline-success" [disabled]="submitVacations">
                            Agendar vacaciones
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <!-- Agendar vacaciones ** end ** -->

    <!-- Agendar capacitacion ** start ** --><!-- 4 -->
    <div *ngIf="flagTypeSession === 11">
        <div class="modal-body">
            <form [formGroup]="capacitationForm" (ngSubmit)="scheduleCapacitation()" novalidate>
                <input type="hidden" name="officeId" id="officeId" formControlName="officeId" />
                <input type="hidden" name="cabinId" id="cabinId" formControlName="cabinId" />
                <input type="hidden" name="employeeId" id="employeeId" formControlName="employeeId" />
                <input type="hidden" name="startDateCap" id="startDateCap" formControlName="startDateCap" />
                
                <div class="row mb-3">
                    <div class="col-md-3 offset-md-2">
                        <label for="startCapacitation"> Hora de inicio </label>
                        <ngb-timepicker [(ngModel)]="startCapacitation" [ngModelOptions]="{ standalone: true }"></ngb-timepicker>
                    </div>

                    <div class="col-md-3 offset-md-2">
                        <label for="endCapacitation"> Hora de fin </label>
                        <ngb-timepicker [(ngModel)]="endCapacitation" [ngModelOptions]="{ standalone: true }" [minuteStep]="step"></ngb-timepicker>

                        <div class="text-danger" *ngIf="!submitCapacitation && endCapacitation.hour === ''">
                            Por favor, selecciona una hora de termino de la capacitacion
                        </div>
                    </div>
                </div>

                <div class="input-group mt-3 mb-3">
                    <span class="input-group-text"> Comentarios* </span>
                    <textarea name="comments" id="comments" class="form-control"
                        formControlName="comments" aria-label="Comentarios"></textarea>
                </div>
                <hr />

                <div class="row">
                    <div class="d-grip gap-2 d-md-flex justify-content-md-end">
                        <button type="submit" class="btn btn-outline-success">
                            Agendar junta
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <!-- Agendar capacitacion ** end ** -->

    <!-- Sesiones de radiofrecuencia ** start ** --><!-- 8 -->
    <div *ngIf="flagTypeSession === 5">
        <div class="alert alert-danger mt-2 ms-2 me-2" role="alert" *ngIf="disabledNewSession">
            {{ messageNewSession }}
        </div>
        <div class="alert alert-danger mt-2 ms-2 me-2" role="alert" *ngIf="flagSessionActive">
            La sesi&oacute;n abarca hora de descanso del colaborador. Por favor cambie la hora de la sesi&oacute;n.
        </div>
        <div class="alert alert-danger mt-2 ms-2 me-2" role="alert" *ngIf="showScheduleSession === 2"> 
            No hay paquetes activos para el cliente seleccionado.
        </div>
        <div class="modal-body">
            <form [formGroup]="apptExists" (ngSubmit)="existsAppointments()" novalidate>
                <input type="hidden" name="officeId" formControlName="officeId" id="officeId" />
                <input type="hidden" name="cabinId" formControlName="cabinId" id="cabinId" />
                <input type="hidden" name="cabinNumber" formControlName="cabinNumber" id="cabinNumber" />
                <input type="hidden" name="apptId" formControlName="apptId" id="apptId" />

                <div class="row">
                    <div class="form-floating col-md-{{ clientColSize }}">
                        <input type="hidden" name="ClientId" id="clientId" formControlName="clientId" required />
                        <select2
                        [data]="clientsFilter"
                        displaySearchStatus="always"
                        style="width: 100%"
                        placeholder="Clientes"
                        resettable
                        listPosition="below"
                        styleMode="material"
                        noResultMessage="Cliente no encontrado"
                        (update)="updateClientPackage($event)"
                        [ngClass]="{
                            'is-invalid': submitAppt && apptExistsFn.clientId.errors,
                            'is-valid': submitAppt && !apptExistsFn.clientId.errors
                        }"></select2>
                    </div>

                    <div class="form-floating mb-3 col-md-6" *ngIf="flagClientOpen">
                        <select name="packageId" id="packageId" class="form-control" formControlName="packageId"
                            required (change)="loadInformationExists($event)"
                            [ngClass]="{
                                'is-valid': submitAppt && !apptExistsFn.packageId.errors,
                                'is-invalid': submitAppt && apptExistsFn.packageId.errors
                            }">
                                <option value="" selected> Selecciona un paquete </option>
                                <option value="{{ package.id }}" *ngFor="let package of packageFilter">
                                    {{ package.type }} {{ package.packageShared }} ({{ package.packageName }} - {{ package.sessionNumber }} sesiones)
                                </option>
                        </select>
                        <label for="packageId" class="ms-2"> Selecciona un paquete </label>
                    </div>
                </div>

                <div *ngIf="showScheduleSession === 1">
                    <div class="row mb-2">
                        <div class="form-check ms-2">
                            <input type="radio" class="form-check-input" id="type1" name="type" value="1"
                                formControlName="type" [checked]="true" checked (change)="isEnabledCustomAreas($event)" />
                            <label for="type1" class="form-check-label"> Sesi&oacute;n completa </label>
                        </div>
                        <div class="form-check ms-2">
                            <input type="radio" class="form-check-input" id="type2" name="type" value="0"
                                formControlName="type" (change)="isEnabledCustomAreas($event)" />
                            <label for="type2" class="form-check-label"> Sesi&oacute;n parcial </label>
                        </div>
                    </div>

                    <div class="row mb-2" *ngIf="showTables">
                        <div *ngIf="apptExistsFn.type?.errors && apptExistsFn.type?.invalid && submitAppt">
                            <div class="text-danger" *ngIf="apptExistsFn.type.errors.required">
                                Seleccione un tipo de sesi&oacute;n
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="flagCustom" formControlName="flagCustom"
                                    (change)="showHideSimpleAreas($event)" />
                                <label for="select_areas" class="form-check-label">
                                    Selecciona areas especificas
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="row" *ngIf="flagSimpleArea && showTables">
                        <div class="col-md-4 mb-2" *ngFor="let areasSelected of areasPackageSelected">
                            <input type="checkbox" class="form-check-input" (change)="storeAreaSelected($event, areasSelected.sess_id)" />
                            <label for="areasSelected"> {{ areasSelected.area }} </label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-floating mb-3 col-md-6">
                            <input type="hidden" name="employeeId" id="employeeId" formControlName="employeeId" />
                            <select name="employeeId" id="employeeId" class="form-control" formControlName="employeeIdTemp" required
                            [ngClass]="{
                                'is-valid': submitAppt && !apptExistsFn.employeeId.errors,
                                'is-invalid': submitAppt && apptExistsFn.employeeId.errors
                            }">
                                <option value="" selected> Selecciona un colaborador </option>
                                <option value="{{ employee.id }}" *ngFor="let employee of employees">
                                    {{ employee.first_name }} {{ employee.last_name }} ({{ employee.email }})
                                </option>
                            </select>
                            <label for="employeeId" class="ms-2"> Selecciona un colaborador </label>
                        </div>

                        <div class="form-floating mb-3 col-md-6">
                            <input type="text" class="form-control" id="totalSessions" name="totalSessions" formControlName="totalSessions"
                                placeholder="Total de sesiones restantes del paquete" required readonly
                                [ngClass]="{
                                    'is-valid': submitAppt && !apptExistsFn.totalSessions.errors,
                                    'is-invalid': submitAppt && apptExistsFn.totalSessions.errors
                                }" />
                            <label for="totalSessions" class="ms-2"> Total de sesiones restantes del paquete </label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6 mb-3 form-floating">
                            <div class="input-group">
                                <input type="text" name="dateSession" class="form-control" id="dateSession" formControlName="dateSession"
                                    placeholder="Fecha de inicio de sesion" ngbDatepicker #d="ngbDatepicker" required readonly style="height: 3.5rem"
                                    [ngClass]="{
                                        'is-valid': submitAppt && !apptExistsFn.dateSession.errors,
                                        'is-invalid': submitAppt && apptExistsFn.dateSession.errors
                                    }" />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()" type="button"></button>
                                <div *ngIf="apptExistsFn.dateSession?.errors && apptExistsFn.dateSession?.invalid && submitAppt">
                                    <div class="text-danger" *ngIf="apptExistsFn.dateSession?.errors.required">
                                        Por favor, seleccione una fecha de sesi&oacute;n
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 mb-3 form-floating">
                            <input type="text" name="sessionNumber" class="form-control" id="sessionNumber" 
                                formControlName="sessionNumber" required
                                [ngClass]="{
                                    'is-valid': submitAppt && !apptExistsFn.sessionNumber.errors,
                                    'is-invalid': submitAppt && apptExistsFn.sessionNumber.errors
                                }" />
                            <label for="sessionNumber" class="ms-2"> Numero de sesi&oacute;n </label>
                            <div *ngIf="apptExistsFn.sessionNumber?.errors && apptExistsFn.sessionNumber?.invalid && submitAppt">
                                <div class="text-danger" *ngIf="apptExistsFn.sessionNumber?.errors.required">
                                    Por favor, selecciona una cita para establecer el numero de sesi&oacute;n.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3 offset-md-2">
                            <label for="startSession"> Hora de inicio </label>
                            <ngb-timepicker [(ngModel)]="startSession" [ngModelOptions]="{ standalone: true }"></ngb-timepicker>
                        </div>

                        <div class="col-md-3 offset-md-2">
                            <label for="endSession"> Hora de fin </label>
                            <ngb-timepicker [(ngModel)]="endSession" [ngModelOptions]="{ standalone: true }" [minuteStep]="step"></ngb-timepicker>
                            <div class="text-danger" *ngIf="submitAppt && (endSession.hour === '' || endSession.minute === '')">
                                Por favor, selecciona una hora de termino de sesi&oacute;n.
                            </div>
                        </div>
                    </div>

                    <div class="input-group mb-3">
                        <span class="input-group-text"> Comentarios </span>
                        <textarea name="comments" id="comments" class="form-control"
                            formControlName="comments" aria-label="Comentarios"
                            [ngClass]="{
                                'is-invalid': submitAppt && apptExistsFn.comments.errors,
                                'is-valid': submitAppt && !apptExistsFn.comments.errors
                            }"></textarea>
                    </div>

                    <div class="row">
                        <div class="d-grip gap-2 d-md-flex justify-content-md-end">
                            <button class="btn btn-outline-success" [disabled]="!disabledScheduleButton">
                                Agendar sesi&oacute;n hidrafacial
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <!-- Sesiones de radiofrecuencia ** end ** -->

    <!-- Agendar maderoterapia ** start ** --><!-- 7 -->
    <div *ngIf="flagTypeSession === 7">
        <div class="alert alert-danger mt-2 ms-2 me-2" role="alert" *ngIf="disabledNewSession">
            {{ messageNewSession }}
        </div>

        <div class="alert alert-danger mt-2 ms-2 me-2" role="alert" *ngIf="flagSessionActive">
            La sesi&oacute;n abarca hora de descanso del colaborador. Por favor cambie la hora de la sesi&oacute;n.
        </div>

        <div class="alert alert-danger mt-2 ms-2 me-2" role="alert" *ngIf="showScheduleSession === 2">
            No hay paquetes activos para el cliente seleccionado
        </div>

        <div class="modal-body">
            <form [formGroup]="maderoForm" (ngSubmit)="maderoAppointments()" novalidate>
                <input type="hidden" name="officeId" id="officeId" formControlName="officeId" />
                <input type="hidden" name="apptId" id="apptId" formControlName="apptId" />
                <input type="hidden" name="cabinId" id="cabinId" formControlName="apptId" />
                <input type="hidden" name="cabinNumber" id="cabinNumber" formControlName="cabinNumber" />

                <div class="row">
                    <div class="form-floating col-md-{{ clientColSize }}">
                        <input type="hidden" name="clientId" id="clientId" formControlName="clientId" required />

                        <select2 [data]="clientsFilter" displaySearchStatus="always" style="width: 100%" placeholder="Clientes"
                            resettable listPosition="below" styleMode="material" noResultMessage="Cliente no encontrado" 
                            (update)="updateClientPackage($event, 7)"
                            [ngClass]="{
                                'is-invalid': submitAppt && apptMaderoFn.clientId.errors,
                                'is-valid': submitAppt && !apptMaderoFn.clientId.errors
                            }"
                            ></select2>
                    </div> 

                    <div class="form-floating mb-3 col-md-6" *ngIf="flagClientOpen">
                        <select name="packageId" id="packageId" class="form-control" formControlName="packageId"
                            required (change)="loadInformationExists($event)"
                            [ngClass]="{
                                'is-valid': submitAppt && !apptMaderoFn.packageId.errors,
                                'is-invalid': submitAppt && apptMaderoFn.packageId.errors
                            }">
                                <option value="" selected> Seleccione un paquete </option>
                                <option value="{{ package.id }}" *ngFor="let package of packageFilter">
                                    {{ package.type }} {{ package.packageShared }} ({{ package.packageName }} - {{ package.sessionNumber }} sesiones)
                                </option>
                        </select>
                        <label for="packageId" class="ms-2"> Seleccione un paquete </label>
                    </div> 
                </div>

                <div *ngIf="showScheduleSession === 1">
                    <div class="row mb-2">
                        <div class="form-check ms-2">
                            <input type="radio" class="form-check-input" id="type1" name="type" value="1" 
                                formControlName="type"
                                (change)="isEnabledCustomAreas($event)" />
                            <label for="type1" class="form-check-label"> Sesi&oacute;n complete </label>
                        </div>

                        <div class="form-check ms-2">
                            <input type="radio" name="type" class="form-check-input" id="type2"
                                formControlName="type" value="0"
                                (change)="isEnabledCustomAreas($event)" />
                            <label for="type2" class="form-check-label"> Sesi&oacute;n parcial </label>
                        </div>
                        <div *ngIf="submitAppt && apptMaderoFn.type?.errors && apptMaderoFn.type?.invalid">
                            <div class="text-danger"></div>
                        </div>
                    </div>

                    <div class="row mb-2" *ngIf="showTables">
                        <fieldset class="border p-3 mt-2 mb-4">
                            <div class="row" *ngIf="flagSimpleArea">
                                <div class="col-md-4 mb-2" *ngFor="let areas of areasPackageSelected">
                                    <input type="checkbox" class="form-check-input"
                                        (change)="storeAreaSelected($event, areas.sess_id)" />
                                    <label for="areas"> {{ areas.area }} </label>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    <div class="row">
                        <div class="col-md-6 mb-3 form-floating">
                            <input type="hidden" name="employeeId" id="employeeId" formControlName="employeeId" />

                            <select name="employeeId" id="employeeId" class="form-control" formControlName="employeeIdTemp" required
                                [ngClass]="{
                                    'is-valid': submitAppt && !apptMaderoFn.employeeId.errors,
                                    'is-invalid': submitAppt && apptMaderoFn.employeeId.errors
                                }">
                                    <option value="" selected> Selecciona un colaborador </option>
                                    <option value="{{ employee.id }}" *ngFor="let employee of employees">
                                        {{ employee.first_name }} {{ employee.last_name }} ({{ employee.email }})
                                    </option>
                            </select>
                            <label for="employeeId" class="ms-2">
                                Selecciona un colaborador
                            </label>
                        </div>

                        <div class="col-md-6 mb-3 form-floating">
                            <input type="text" name="totalSessions" id="totalSessions" class="form-control" 
                                formControlName="totalSessions" placeholder="Total de sesiones restantes del paquete"
                                required readonly
                                [ngClass]="{
                                    'is-valid': submitAppt && !apptMaderoFn.totalSessions.errors,
                                    'is-invalid': submitAppt && apptMaderoFn.totalSessions.errors
                                }" />
                            <label for="totalSessions" class="ms-1"> Total de sesiones restantes del paquete </label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6 mb-3 form-floating">
                            <div class="input-group">
                                <input type="text" class="form-control" id="dateSession" name="dateSession" formControlName="dateSession"
                                    placeholder="Fecha de inicio de sesi&oacute;n" ngbDatepicker #d="ngbDatepicker" required
                                    readonly style="height: 3.5rem"
                                    [ngClass]="{
                                        'is-valid': submitAppt && !apptMaderoFn.dateSession.errors,
                                        'is-invalid': submitAppt && apptMaderoFn.dateSession.errors
                                    }" />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()" type="button"></button>
                            </div>

                            <div *ngIf="apptMaderoFn.dateSession?.errors && apptMaderoFn.dateSession?.invalid && submitAppt">
                                <div class="text-danger" *ngIf="apptMaderoFn.dateSession.errors.required">
                                    Por favor, selecciona una fecha de sesi&oacute;n
                                </div>
                            </div>                            
                        </div>

                        <div class="col-md-6 mb-3 form-floating">
                            <input type="text" class="form-control" id="sessionNumber" name="sessionNumber"
                                placeholder="Numero de sesi&oacute;n" required formControlName="sessionNumber"
                                [ngClass]="{
                                    'is-valid': submitAppt && !apptMaderoFn.sessionNumber.errors,
                                    'is-invalid': submitAppt && apptMaderoFn.sessionNumber.errors
                                }">
                            <label for="sessionNumber" class="ms-2"> Numero de sesi&oacute;n </label>

                            <div *ngIf="apptMaderoFn.sessionNumber?.errors && apptMaderoFn.sessionNumber?.invalid && submitAppt">
                                <div class="text-danger" *ngIf="apptMaderoFn.sessionNumber?.errors.required">
                                    Por favor, selecciona una cita para despues establecer el numero de sesi&oacute;n
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-md-3 offset-md-2">
                            <label for="startSession"> Hora de inicio </label>
                            <ngb-timepicker [(ngModel)]="startSession" [ngModelOptions]="{ standalone: true }"></ngb-timepicker>
                        </div>

                        <div class="col-md-3 offset-md-2">
                            <label for="endSession"> Hora de fin </label>
                            <ngb-timepicker [(ngModel)]="endSession" [ngModelOptions]="{ standalone: true }" [minuteStep]="step"></ngb-timepicker>

                            <div class="text-danger" *ngIf="submitAppt && (endSession.hour === '' || endSession.minute === '')">
                                Por favor, selecciona la hora de terminaci&oacute;n de la sesi&oacute;n
                            </div>
                        </div>
                    </div>

                    <div class="input-group mb-3">
                        <span class="input-group-text"> Comentarios </span>
                        <textarea name="comments" id="comments" class="form-control" formControlName="comments" aria-label="Comentarios"
                            [ngClass]="{
                                'is-invalid': submitAppt && apptMaderoFn.comments.errors,
                                'is-valid': submitAppt && !apptMaderoFn.comments.errors
                            }"></textarea>
                    </div>

                    <div class="row">
                        <div class="d-grip gap-2 d-md-flex justify-content-md-end">
                            <button type="submit" class="btn btn-outline-success" [disabled]="!disabledScheduleButton">
                                Agendar sesi&oacute;n
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <!-- Agendar maderoterapia ** end ** -->
</ng-template>
<!-- Create session ** end ** -->

<!-- Change time session ** start ** -->
<ng-template #changeTime let-close="close">
    <div class="modal-header">
        <h5 class="modal-title"> Cambiar hora de la cita </h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form [formGroup]="changeTimeForm" (ngSubmit)="changeHourSession()" novalidate>
            <input type="hidden" name="sessionId" id="sessionId" formControlName="sessionId" />

            <div class="row">
                <div class="col-md-3 offset-md-2">
                    <label for="changeTimeStart"> Hora de inicio </label>
                    <ngb-timepicker [(ngModel)]="changeTimeStart" [ngModelOptions]="{ standalone: true }"></ngb-timepicker>
                </div>

                <div class="col-md-3 offset-md-2">
                    <label for="changeTimeEnd"> Hora de fin </label>
                    <ngb-timepicker [(ngModel)]="changeTimeEnd" [ngModelOptions]="{ standalone: true }" [minuteStep]="step"></ngb-timepicker>
                </div>
            </div>

            <div class="row">
                <div class="d-grip gap-2 d-md-flex justify-content-md-end">
                    <button type="submit" class="btn btn-outline-success" [disabled]="disabledChangeTimeMessage">
                        Cambiar horario de la sesi&oacute;n
                    </button>
                </div>
            </div>
        </form>
    </div>
</ng-template>
<!-- Change time session ** end ** -->

<!-- Historical Comments ** start ** -->
<ng-template #historicalComments let-close="close">
    <div class="modal-header">
        <h5 class="modal-title"> Historial de comentarios </h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true"> &times; </span>
        </button>
    </div>
    <div class="modal-body">
        <div *ngIf="historicalCommentsInfo.length === 0">
            <div class="alert alert-danger" role="alert">
                No hay comentarios actualmente
            </div>
        </div>
        <div *ngIf="historicalCommentsInfo.length !== 0">
            <div *ngFor="let comment of historicalCommentsInfo">
                <div class="card mb-2">
                    <div class="card-header">
                        Comentario de la sesi&oacute;n {{ comment.session_number }} (<small>{{ comment.created_at }}</small>)
                    </div>
                    <div class="card-body">
                        {{ comment.comment }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<!-- Historical Comments ** end ** -->

<!-- Data Sessions per Client ** start ** -->
<ng-template #sessionsClients let-close="close">
    <div class="modal-header">
        <h5 class="modal-title"> Informacion de sesiones de <strong>{{ clientName }}</strong></h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true"> &times; </span>
        </button>
    </div>
    <div class="modal-body" *ngIf="flagSearchModal">
        <div class="mb-2 alert alert-danger" role="alert">
            No hay sesiones programadas para el cliente seleccionado!
        </div>
        <div class="row">
            <div class="d-grip gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-danger" (click)="close()">
                    Cerrar
                </button>
            </div>
        </div>
    </div>
    <div class="modal-body">
        <div>
            <div class="card mt-2">
                <div class="ms-1 me-1">
                    <table class="table table-striped">
                        <thead class="table-dark">
                            <tr>
                                <th class="col"> # de sesi&oacute;n </th>
                                <th class="col"> Inicio </th>
                                <th class="col"> Fin </th>
                                <th class="col"> Asistio? </th>
                                <th class="col"> Atendio </th>
                                <th class="col"> Areas del paquete </th>
                                <th class="col"> Total de sesiones </th>
                                <th class="col"> &nbsp; </th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let session of perClients">
                            <tr>
                                <td> Sesi&oacute;n {{ session.number_session }} </td>
                                <td> {{ session.session_start }} </td>
                                <td> {{ session.session_end }} </td>
                                <td> {{ session.assisted ? 'Si' : 'No' }} </td>
                                <td> {{ session.real_user.name.length === 0 ? session.user.name : session.real_user.name }} </td>
                                <td> {{ session.areas_session }} </td>
                                <td> {{ session.package.session_number }} </td>
                                <td>
                                    <button type="button" class="btn btn-success" (click)="calendarPerClient(session)">
                                        Ir a la sesi&oacute;n
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<!-- Data Sessions per Client ** end ** -->

<!-- Close box modal ** start ** -->
<ng-template #closeBoxModal let-close="close">
    <div class="modal-header">
        <h5 class="modal-title"> Corte de caja </h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true"> &times; </span>
        </button>
    </div>
    <div class="modal-body">
        <div class="card mt-2" *ngFor="let box of closeBox">
            <div class="card-body" *ngIf="!box.pay.data.length">
                <div class="alert alert-danger" role="alert">
                    No hay ingresos con <strong>"{{ box.pay.method_name }}"</strong>
                </div>
            </div>
            <div class="card-body" *ngIf="box?.pay?.data?.length">
                <h5 class="card-title"> {{ box.pay.method_name }} </h5>
                <table class="table table-striped mt-2">
                    <thead class="table-dark">
                        <tr>
                            <th class="col"> Resumen </th>
                            <th class="col"> Pago </th>
                            <th class="col"> Fecha de venta </th>
                            <th class="col"> Areas </th>
                            <th class="col"> Metodo de pago </th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let cb of box.pay.data">
                        <tr>
                            <td> {{ cb.title }} </td>
                            <td> {{ cb.pago | currency }} </td>
                            <td> {{ cb.venta }} </td>
                            <td> {{ cb.areas }} </td>
                            <td> {{ cb.method }} </td>
                        </tr>
                    </tbody>
                </table>
                <div class="row mt-1 justify-content-md-end fw-bold" style="margin-right: 5px !important;">
                    Total: {{ box.pay.total | currency }}
                </div>
                <div class="d-grip gap-2 d-md-flex justify-content-md-end mt-2" *ngIf="box.pay.existsData === 0">
                    <button type="button" class="btn btn-outline-success"
                        (click)="confirmData(1, box.pay.total, box.pay.id_method, box.pay.date_send)">
                        Confirmar
                    </button>
                    <button type="button" class="btn btn-outline-danger"
                        (click)="confirmData(0, box.pay.total, box.pay.id_method, box.pay.date_send)">
                        Rechazar
                    </button>
                </div>
            </div>
        </div>
        <div class="card mt-2">
            <div class="card-body" *ngIf="!closeBoxChange?.change_office?.length">
                <div class="alert alert-danger" role="alert">
                    No hay clientes con cambios de sucursal.
                </div>
            </div>
            <div class="card-body" *ngIf="closeBoxChange?.change_office?.length">
                <h5 class="card-title"> Cambios de sucursal </h5>
                <table class="table table-striped mt-2">
                    <thead class="table-dark">
                        <tr>
                            <th class="col"> Cliente </th>
                            <th class="col"> Pago </th>
                            <th class="col"> Fecha de cambio </th>
                            <th class="col"> Metodo de pago </th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let changeCloseBox of closeBoxChange.change_office">
                        <tr>
                            <td> {{ changeCloseBox.cliente }} </td>
                            <td> {{ changeCloseBox.pago | currency }} </td>
                            <td> {{ changeCloseBox.venta }} </td>
                            <td> {{ changeCloseBox.method }} </td>
                        </tr>
                    </tbody>
                </table>
                <div class="row mt-1 justify-content-end fw-bold" style="margin-right: 5px !important;">
                    Total: {{ closeBoxChange.total | currency }}
                </div>
                <div class="d-grid gap-2 d-md-flex justify-content-md-end mt-2" *ngIf="closeBoxChange.paymentClose === 0">
                    <button type="button" class="btn btn-outline-success"
                        (click)="confirmChangeData(1, closeBoxChange.total, closeBoxChange.date_send)">
                        Confirmar
                    </button>
                    <button type="button" class="btn btn-outline-danger"
                        (click)="confirmChangeData(0, closeBoxChange.total, closeBoxChange.date_send)">
                        Rechazar
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="close()">
            Cerrar
        </button>
    </div>
</ng-template>
<!-- Close box modal ** end ** -->

<!-- Schedule Vacations modal ** start ** -->
<ng-template #scheduleVacationsModal let-close="close">
    <div class="modal-header">
        <h5 class="modal-title"> Agendar vacaciones </h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true"> &times; </span>
        </button>
    </div>
    <div class="modal-body">
        <form [formGroup]="vacationsForm" (ngSubmit)="scheduleVacations()" novalidate>
            <input type="hidden" name="officeId" formControlName="officeId" />
            <input type="hidden" name="cabinId" formControlName="cabinId" />
            <input type="hidden" name="employeeId" formControlName="employeeId" />

            <div class="row">
                <select2 [data]="filterEmployees" displaySearchStatus="always" style="width: 100%" placeholder="Colaboradores"
                    resettable listPosition="below" styleMode="material" noResultMessage="Colaborador no encontrado"
                    (update)="updateClientsVacations($event)" 
                    [ngClass]="{
                        'is-invalid': submitVacations && vacationsFormFn.temporalEmployeeId.errors,
                        'is-valid': submitVacations && !vacationsFormFn.temporalEmployeeId.errors
                    }"></select2>
            </div>

            <div class="row">
                <div class="col-md-6 mb-3 form-floating">
                    <div class="input-group">
                        <input type="text" name="startDate" class="form-control" id="startDate" formControlName="startDate"
                            placeholder="Fecha de inicio de vacaciones" ngbDatepicker #d="ngbDatepicker" required readonly style="height: 3.5rem;"
                            [ngClass]="{
                                'is-valid': submitVacations && !vacationsFormFn.startDate.errors,
                                'is-invalid': submitVacations && vacationsFormFn.startDate.errors
                            }" />
                        <button type="button" class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()"></button>
                        <div *ngIf="vacationsFormFn.startDate?.invalid && vacationsFormFn.startDate?.errors && submitVacations">
                            <div class="text-danger" *ngIf="vacationsFormFn.startDate.errors.required">
                                Por favor, seleccione una fecha de inicio de vacaciones.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 mb-3 form-floating">
                    <div class="input-group">
                        <input type="text" name="endDate" class="form-control" id="endDate" formControlName="endDate"
                            placeholder="Fecha de termino de vacaciones" ngbDatepicker
                            #d2="ngbDatepicker" required readonly style="height: 3.5rem;"
                            [ngClass]="{
                                'is-valid': submitVacations && !vacationsFormFn.endDate.errors,
                                'is-invalid': submitVacations && vacationsFormFn.endDate.errors
                            }" />
                        <button type="button" class="btn btn-outline-secondary bi bi-calendar3" (click)="d2.toggle()"></button>
                        <div *ngIf="vacationsFormFn.endDate?.errors && vacationsFormFn.endDate?.invalid && submitVacations">
                            <div class="text-danger" *ngIf="vacationsFormFn.endDate.errors.required">
                                Por favor, seleccione una fecha de termino de las vacaciones.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-3 offset-md-2">
                    <label for="startVacations">Hora de inicio</label>
                    <ngb-timepicker [(ngModel)]="startVacations" [ngModelOptions]="{ standalone: true }" [minuteStep]="step"></ngb-timepicker>
                </div>
                <div class="col-md-3 offset-md-2">
                    <label for="endVacations">Hora de termino</label>
                    <ngb-timepicker [(ngModel)]="endVacations" [ngModelOptions]="{ standalone: true }" [minuteStep]="step"></ngb-timepicker>
                </div>
            </div>

            <div class="row mt-2">
                <div class="d-grip gap-2 d-md-flex justify-content-md-end">
                    <button type="submit" class="btn btn-outline-success" [disabled]="submitVacations">
                        Agendar vacaciones
                    </button>
                </div>
            </div>
        </form>
    </div>
</ng-template>
<!-- Schedule Vacations modal ** end ** -->

<!-- Confirm assisted ** start ** -->
<ng-template #confirmAssisted let-close="close">
    <div class="modal-header">
        <h5 class="modal-title"> 
            Confirmar Asistencia
            <button type="button" class="btn btn-outline-danger ms-2" (click)="deleteSession(dataSessionInfo.session_id)">
                <span *ngIf="dataSessionInfo.typeSession !== 2">
                    Eliminar Sesi&oacute;n
                </span>
                <span *ngIf="dataSessionInfo.typeSession === 2">
                    Eliminar Valoraci&oacute;n
                </span>
            </button>
            <button type="button" class="btn btn-outline-success ms-2" (click)="showFormEditSession($event)">
                Editar Sesi&oacute;n
            </button>
        </h5>
        <button class="close ms-auto" type="button" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="card mt-2">
            <div class="card-body">
                <div class="mb-2 alert {{ typeColor }}" role="alert" *ngIf="disabledAcceptanceButton">
                    {{ messageAcceptance }}
                </div>

                <div *ngIf="editHourSession">
                    <div class="card mb-1">
                        <div class="card-body">
                            <h5 class="card-title mb-1">
                                Cambio del horario de la sesi&oacute;n
                            </h5>
                            <div class="card-title">
                                <form [formGroup]="updateFormSession" (ngSubmit)="updateDataSession()" novalidate>
                                    <input type="hidden" name="sessionId" id="sessionId" formControlName="sessionId" />
                                    <input type="hidden" name="originalCabin" id="originalCabin" formControlName="originalCabin" />
                                    <input type="hidden" name="duration" id="duration" formControlName="duration" />

                                    <div class="row mb-3">
                                        <div class="col-md-3 offset-md-2">
                                            <label for="startSession"> Hora de inicio </label>
                                            <ngb-timepicker [(ngModel)]="startSession" [ngModelOptions]="{ standalone: true }"
                                                [spinners]="true" (ngModelChange)="changeHour(true)"></ngb-timepicker>
                                        </div>

                                        <div class="col-md-3 offset-md-2">
                                            <label for="endSession"> Hora de fin </label>
                                            <ngb-timepicker [(ngModel)]="endSession" [ngModelOptions]="{ standalone: true }"
                                                [minuteStep]="step" [spinners]="true"></ngb-timepicker>
                                            <div class="text-danger"></div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="form-floating mb-3 mt-3 col-md-12">
                                            <select name="cabinNumber" id="cabinNumber" class="form-select" 
                                                aria-label="floating label select" formControlName="cabinNumber">
                                                    <option value="" selected> Selecciona una cabina </option>
                                                    <option value="{{ cabin.id }}" *ngFor="let cabin of cabins">
                                                        {{ cabin.name }}
                                                    </option>
                                            </select>
                                            <label for="cabinNumber" class="ms-2">
                                                Selecciona una cabina
                                            </label>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="d-grip gap-2 d-md-flex justify-content-md-end">
                                            <button type="submit" class="btn btn-outline-success">
                                                Aceptar cambio de horario
                                            </button>

                                            <button type="button" class="btn btn-outline-danger" (click)="showFormEditSession($event)">
                                                Cancelar
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="ms-1 me-1 btn-group">
                        <button type="button" class="btn btn-success" (click)="confirmAssitedToSession(1, dataSessionInfo?.session_id)"
                            [disabled]="disabledAcceptanceButton">
                                <i class="bi bi-check2-circle icon-color-button"></i>
                                Confirmo asistencia
                        </button>

                        <button type="button" class="btn btn-danger ms-1" (click)="openNoAssisstForm(true, 1)"
                            [disabled]="disabledAcceptanceButton">
                                <i class="bi bi-x-circle icon-color-button"></i>
                                Confirmo no asistencia
                        </button>

                        <button type="button" class="btn btn-warning ms-1" (click)="showRescheduleForm(true)">
                            <i class="bi bi-calendar3"></i>
                            Reagendar
                        </button>
                    </div>
                </div>
            </div>

            <div class="alert alert-success mt-2 ms-2 me-2" role="alert" *ngIf="submitReschedule && messageTextReschedule">
                {{ messageTextReschedule }}
            </div>

            <div class="card mb-1 ms-1 me-1" *ngIf="noAssistFlag">
                <div class="card-body">
                    <h5 class="card-title">
                        Raz&oacute;n de <strong>No Asistencia</strong>
                    </h5>

                    <div class="card-title">
                        <form [formGroup]="cancelForm" (ngSubmit)="confirmAssitedToSessionPost()" novalidate>
                            <input type="hidden" name="id" formControlName="id" />
                            <input type="hidden" name="type" formControlName="type" />

                            <div class="row">
                                <div class="mb-3 input-group">
                                    <span class="input-group-text"> Comentarios </span>
                                    <textarea name="comments" id="comments" class="form-control" 
                                        formControlName="comments" aria-label="Comentarios"></textarea>
                                </div>
                            </div>

                            <div class="row">
                                <div class="d-grip-gap-2 d-md-flex justify-content-md-end">
                                    <button type="submit" class="btn btn-outline-success me-1">
                                        Confirmar no asistencia
                                    </button>

                                    <button type="button" class="btn btn-outline-danger" (click)="openNoAssisstForm(false, 0)">
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div class="card mb-1" *ngIf="rescheduleFlag">
                <div class="card-body">
                    <h5 class="card-title">
                        Reagendar Sesi&oacute;n
                    </h5>

                    <div class="card-title">
                        <form [formGroup]="rescheduleForm" (ngSubmit)="rescheduleSession()" novalidate>
                            <input type="hidden" name="sessionId" formControlName="sessionId" />

                            <div class="row">
                                <div class="mb-3 form-floating">
                                    <div class="input-group">
                                        <input type="text" name="newDay" id="newDay" class="form-control" formControlName="newDay" style="height: 3.5rem"
                                            placeholder="Fecha a reagendar sesión" ngbDatepicker #d="ngbDatepicker" required readonly
                                            [ngClass]="{
                                                'is-valid': submitReschedule && !rescheduleSessionFn.newDay.errors,
                                                'is-invalid': submitReschedule && rescheduleSessionFn.newDay.errors
                                            }" />
                                        <button type="button" class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()"></button>

                                        <div *ngIf="rescheduleSessionFn.newDay.errors && rescheduleSessionFn.newDay.invalid && submitReschedule">
                                            <div class="text-danger" *ngIf="rescheduleSessionFn.newDay.errors.required">
                                                Por favor, seleccione una fecha para reagendar la sesi&oacute;n
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-md-3 offset-md-2">
                                    <label for="startSession"> Hora de inicio </label>
                                    <ngb-timepicker [(ngModel)]="startSession" [ngModelOptions]="{ standalone: true}" [spinners]="true"></ngb-timepicker>
                                </div>

                                <div class="col-md-3 offset-md-2">
                                    <label for="endSession"> Hora de termino </label>
                                    <ngb-timepicker [(ngModel)]="endSession" [ngModelOptions]="{ standalone: true}" [minuteStep]="step"     
                                        [spinners]="true"></ngb-timepicker>
                                    
                                    <div class="text-danger" *ngIf="submitExists">
                                        Por favor, seleccione una hora de termino de sesi&oacute;n
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="d-grip gap-2 d-md-flex justify-content-md-end">
                                        <button class="btn btn-outline-success" type="submit">
                                            Aceptar reagenda
                                        </button>

                                        <button type="button" class="btn btn-outline-danger" (click)="showRescheduleForm(false)">
                                            Cancelar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<!-- Confirm assisted ** end ** -->

<!-- Icons Map Modal ** start ** -->
<ng-template #iconsMap let-close="close">
    <div class="modal-header">
        <h5 class="modal-title"> Mapa de Iconos </h5>
        <button class="close" type="button" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="card-body">
            <table class="table table-stripe">
                <thead>
                    <tr>
                        <th class="col"> Icono </th>
                        <th class="col"> Significado </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="col">🤩</td>
                        <td class="col">Nombre del cliente</td>
                    </tr>
                    <tr>
                        <td class="col"><i class="bi bi-check-circle-fill text-success"></i></td>
                        <td class="col">Sesi&oacute;n confirmada</td>
                    </tr>
                    <tr>
                        <td class="col"><i class="bi bi-x-circle text-danger"></i></td>
                        <td class="col">Sesi&oacute;n no confirmada</td>
                    </tr>
                    <tr>
                        <td class="col"><i class="bi bi-person-check text-success"></i></td>
                        <td class="col">Asistencia confirmada - Si asistio</td>
                    </tr>
                    <tr>
                        <td class="col"><i class="bi bi-person-x text-danger"></i></td>
                        <td class="col">Asistencia confirmada - No asistio</td>
                    </tr>
                    <tr>
                        <td class="col"><i class="bi bi-person-exclamation text-warning"></i></td>
                        <td class="col">Asistencia no confirmada - Pendiente asistencia</td>
                    </tr>
                    <tr>
                        <td class="col">📞</td>
                        <td class="col">Telefono</td>
                    </tr>
                    <tr>
                        <td class="col">⏰</td>
                        <td class="col">Hora que se agendo la sesi&oacute;n</td>
                    </tr>
                    <tr>
                        <td class="col">🏃‍➡️</td>
                        <td class="col">Areas a trabajar en la sesi&oacute;n</td>
                    </tr>
                    <tr>
                        <td class="col">💬</td>
                        <td class="col">Comentarios de la sesi&oacute;n / valoraci&oacute;n</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</ng-template>
<!-- Icons Map Modal ** start ** -->
